export default {
    "cs": {
        "Ordering service": "Objednávková služba",
        "Ordering services": "Objednávkové služby",
        "Title": "Název",
        "Provider": "Poskytovatel",
        "Own/Custom service": "Vlastní/Jiná služba",
        "Content": "Obsah",
        "Prologue": "Úvod",
        "Save and leave": "Uložit a odejít",
        "Link": "Odkaz",
        "Display": "Zobrazení",
        "Availability": "Dostupnost",
        "datetime": {
            "days": {
                "1": "Pondělí",
                "2": "Úterý",
                "3": "Středa",
                "4": "Čtvrtek",
                "5": "Pátek",
                "6": "Sobota",
                "7": "Neděle",
                "8": "Státní svátky"
            },
            "daysShort": {
                "1": "Po",
                "2": "Út",
                "3": "St",
                "4": "Čt",
                "5": "Pá",
                "6": "So",
                "7": "Ne",
                "8": "Sv"
            },
            "from": "od",
            "nextWeek": "Příští týden",
            "thisWeek": "Tento týden",
            "today": "Dnes",
            "tomorrow": "Zítra",
            "until": "do"
        },
        "settings": {
            "contact": {
                "address": {
                    "description": "Adresa, kde se podnik nachází",
                    "hint": "Adresa bude použita nejen pro zobrazení, ale i pro dohledání lokace na google mapách."
                },
                "email": {
                    "description": "E-mail"
                },
                "ic": {
                    "description": "IČ provozovatele podniku"
                },
                "info": {
                    "description": "Dodatečné údaje na kontaktní stránce"
                },
                "module": "Kontakty",
                "name": {
                    "description": "Označení podniku (jak bude vidět na webu)"
                },
                "operator": {
                    "description": "Označení provozovatele podniku"
                },
                "phone": {
                    "description": "Telefonní číslo"
                },
                "show_email": {
                    "description": "Zobrazovat e-mail na webu"
                },
                "show_kitchen": {
                    "description": "Zobrazit otevírací dobu kuchyně"
                }
            },
            "cta": {
                "custom_style": {
                    "description": "Vlastní styl",
                    "hint": "Použije se pouze pro CTA typu \"Vlastní\".",
                    "options": {
                        "black": "Černé tlačítko",
                        "blue": "Modré tlačítko",
                        "danger": "Červené tlačítko",
                        "success": "Zelené tlačítko",
                        "warning": "Žluté tlačítko",
                        "white": "Bílé tlačítko"
                    }
                },
                "custom_text": {
                    "description": "Vlastní text",
                    "hint": "Použije se pouze pro CTA typu \"Vlastní\"."
                },
                "custom_url": {
                    "description": "Vlastní odkaz",
                    "hint": "Použije se pouze pro CTA typu \"Vlastní\"."
                },
                "module": "Výzva k akci (CTA)",
                "type": {
                    "description": "Typ",
                    "options": {
                        "contact": "Kontaktní stránka",
                        "custom": "Vlastní",
                        "none": "Žádná",
                        "order_online": "Online objednávka",
                        "phone": "Telefonní číslo",
                        "table_reservation": "Rezervace stolu"
                    }
                }
            },
            "external": {
                "facebook_pixel": {
                    "description": "Facebook Pixel",
                    "hint": "Vkládejte pouze ID měření, např.: <strong>926140414437894</strong>"
                },
                "google_analytics": {
                    "description": "Google Universal Analytics",
                    "hint": "Vkládejte pouze číslo pro měření, např.: <strong>UA-123456789-3</strong>"
                },
                "google_analytics_4": {
                    "description": "Google Analytics 4",
                    "hint": "Vkládejte pouze ID měření, např.: <strong>G-ABCDEFG123</strong>"
                },
                "google_ads": {
                    "description": "Google Ads",
                    "hint": "Vkládejte pouze ID měření, např.: <strong>AW-123456789</strong>"
                },
                "google_tag_manager": {
                    "description": "Google Tag Manager",
                    "hint": "Vkládejte pouze GTM kód, např.: <strong>GTM-ABCDEFG</strong>"
                },
                "module": "Měřící kód"
            },
            "font": {
                "display": {
                    "description": "Písmo - Nadpisy",
                    "options": {
                        "alice": "Alice",
                        "varela-round": "Varela Round",
                        "blink-mac": "Blink Mac",
                        "caveat": "Caveat",
                        "comfortaa": "Comfortaa",
                        "cormorant-infant": "Cormorant Infant",
                        "cormorant-sc": "Cormorant SC",
                        "eb-garamond": "EB Garamond",
                        "lobster": "Lobster",
                        "lora": "Lora",
                        "merriweather": "Merriweather",
                        "montserrat": "Montserrat",
                        "overpass": "Overpass",
                        "pacificio": "Pacifico",
                        "palanquin-dark": "Palanquin Dark",
                        "playfair-display": "Playfair Display",
                        "prata": "Prata",
                        "pt-sans": "PT Sans",
                        "roboto": "Roboto",
                        "ubuntu": "Ubuntu",
                        "yeseva-one": "Yeseva One",
                        "dm-serif-display": "DM Serif Display"
                    }
                },
                "module": "Písmo",
                "text": {
                    "description": "Písmo - Základní",
                    "options": {
                        "blink-mac": "Blink Mac",
                        "lora": "Lora",
                        "merriweather": "Merriweather",
                        "montserrat": "Montserrat",
                        "open-sans": "Open Sans",
                        "raleway": "Raleway",
                        "roboto": "Roboto",
                        "ubuntu": "Ubuntu",
                        "varela-round": "Varela Round"
                    }
                }
            },
            "gallery": {
                "label": {
                    "description": "Označení galerie na webu",
                    "hint": "Vyplňte pouze v případě, kdy chcete změnit výchozí označení z výrazu \"Galerie\" na jiný. Pozor dojde i ke změně URL adresy, na kterém je galerie dostupná."
                },
                "module": "Galerie",
                "thumbnail": {
                    "description": "Způsob zobrazení náhledu fotografií",
                    "hint": "<strong>cover</strong> (výchozí) - vhodné pokud máte většinu fotek tzv. na šířku, dochází k ořezávání fotek<br /><strong>fit</strong> - vhodné pokud máte různorodý formát fotek, nedochází k ořezávání fotek",
                    "options": {
                        "cover": "Vyplnit",
                        "fit": "Oříznout"
                    }
                }
            },
            "general": {
                "footer": {
                    "description": "Doplňkový obsah v patičce"
                },
                "background_image": {
                    "description": "Obecné - Obrázek na pozadí",
                    "hint": "Obrázek, který se používá na pozadí (viditelný poukud je nastaveno fixní zobrazení nebo pokud je povolený i jako obrázek do hlavičky)."
                },
                "box": {
                    "description": "Obecné - Vzhled boxů",
                    "options": {
                        "heavy": "Výrazný",
                        "lite": "Jednoduchý",
                        "relief": "Reliéf",
                        "shadow": "Stín",
                        "smooth": "Jemný"
                    }
                },
                "floated_logo": {
                    "description": "",
                    "hint": ""
                },
                "footer_style": {
                    "description": "Patička - Barva",
                    "hint": "Ovlivňuje barvu patičky webové stránky.",
                    "options": {
                        "black": "Černá",
                        "dark": "Tmavá",
                        "light": "Světlá",
                        "white": "Bílá"
                    }
                },
                "logo": {
                    "description": "Logo restaurace"
                },
                "logo_dark": {
                    "description": "Obecné - Tmavé logo restaurace",
                    "hint": "Pro použití na světlém pozadí."
                },
                "logo_light": {
                    "description": "Obecné - Světlé logo restaurace",
                    "hint": "Pro použití na tmavém pozadí."
                },
                "logo_pdf": {
                    "description": "Logo restaurace pro PDF export"
                },
                "module": "Vzhled",
                "nav_bar_shadow": {
                    "description": "Navigační lišta - Stínování",
                    "options": {
                        "shadow-heavy": "Výrazné",
                        "shadow-light": "Jemné",
                        "shadow-none": "Bez stínování"
                    }
                },
                "nav_bar_size": {
                    "description": "Navigační lišta - Výška",
                    "hint": "Ovlivňuje výšku navigační lišty.",
                    "options": {
                        "is-large": "Velká",
                        "is-medium": "Střední",
                        "is-small": "Malá"
                    }
                },
                "navbar_logo_size": {
                    "description": "Navigační lišta - Velikost loga",
                    "hint": "POZOR, velikost logo je pokročilé nastavení, které standartně nastavují pouze pracovníci z wistro.cz. Pro jinou než výchozí volbu je třeba mít vhodný formát obrázku.",
                    "options": {
                        "default": "Výchozí",
                        "float": "Plovoucí",
                        "full": "Vyplnit"
                    }
                },
                "navigation_content_position": {
                    "description": "Navigační lišta - Umístění odkazů",
                    "options": {
                        "center": "Uprostřed",
                        "left": "Vlevo",
                        "right": "Vpravo",
                        "split": "Rozdělit"
                    }
                },
                "navigation_highlight": {
                    "description": "Navigační lišta - Zvýraznění",
                    "hint": "Ovlivňuje jakým způsobem se zvýrazní právě aktivní položka v navigační liště a položka na kterou návštěvník najede myší.",
                    "options": {
                        "has-highlight-background": "Pozadí",
                        "has-highlight-color": "Odstín",
                        "has-highlight-underline": "Podrtžení"
                    }
                },
                "navigation_transparent": {
                    "description": "Navigační lišta - Průhlednost",
                    "hint": "Ovlivňuje zda je navigační lišta ve výchozí poloze průhledná. Průhledná navigační lišta se zobrazí pouze pokud je na dané stránce v hlavičce podkladový obrázek. V nastavení je dále dostupná i volba, pomocí které je možné globálně doplnit podkladový obrázek do všech stránek.",
                    "options": [
                        "Ne",
                        "Ano"
                    ]
                },
                "navigation_width": {
                    "description": "Navigační lišta - Šířka",
                    "options": {
                        "fixed": "Fixní",
                        "fluid": "Responzivní"
                    }
                },
                "notifications_above_navigation": {
                    "description": "Navigační lišta - Umístění notifikací",
                    "hint": "Ovlivňuje, kde zda se rychlé upozornění (notifikace) zobrazají nad nebo pod navigační lištou.",
                    "options": [
                        "Pod navigační lištou",
                        "Nad navigační lištou"
                    ]
                },
                "padding": {
                    "description": "Obecné - Prostor okolo prvků",
                    "options": {
                        "large": "Velký",
                        "medium": "Střední",
                        "small": "Malý"
                    }
                },
                "primary_color": {
                    "description": "Navigační lišta - Barva",
                    "hint": "Ovlivňuje barvu hlavní navigační lišty.",
                    "options": {
                        "black": "Černá",
                        "blue": "Modrá",
                        "brown": "Hnědá",
                        "dark": "Tmavá",
                        "green": "Zelená",
                        "light": "Světlá",
                        "red": "Červená",
                        "white": "Bílá",
                        "yellow": "Žlutá"
                    }
                },
                "secondary_color": {
                    "description": "Obecné - Sekundární barva",
                    "hint": "Ovlivňuje barvu většiny nadpisů, šipky pro rychlé vyrolování webu nahoru a podkladovou barvu pro zvýrazněné kategorie jídelního lístku. Rozdíly v barvě nadpisů mohou být u některých témat vzhledem k tloušťce písem velmi jemné.",
                    "options": {
                        "black": "Černá",
                        "blue": "Modrá",
                        "brown": "Hnědá",
                        "dark": "Tmavá",
                        "green": "Zelená",
                        "red": "Červená"
                    }
                },
                "social_accounts_style": {
                    "description": "Patička - Sociální sítě",
                    "hint": "Ovlivňuje styl ikonek sociálních sítí zobrazených v patičce.",
                    "options": {
                        "round-bw": "Černobílý kroužek",
                        "round-color": "Barevný kroužek",
                        "square-bw": "Černobílý čtvereček",
                        "square-color": "Barevný čtvereček"
                    }
                },
                "theme": {
                    "description": "Obecné - Wistro téma",
                    "hint": "Jemně ovlivňuje většinu prvků celého webu, tj. například písma, odstíny, přechody, tlačítka a významněji potom hlavní navigační lištu. Volba Wistro tématu je čistě pocitová záležitost.",
                    "options": {
                        "cerulean": "Cerulean",
                        "default": "Bulma",
                        "lumen": "Lumen",
                        "putty": "Putty",
                        "sandstone": "Sandstone"
                    }
                },
                "title_size": {
                    "description": "Obecné - Velikost nadpisů",
                    "hint": "Ovlivňuje velikost plochy pro hlavní nadpisy v případě, že hlavička obsahuje i ilustrační obrázek. Hlavičky bez ilustračního obrázku se vždy zobrazí v malé variantě.",
                    "options": {
                        "is-large": "Velká",
                        "is-larger": "Větší",
                        "is-largest": "Největší",
                        "is-medium": "Střední",
                        "is-small": "Malá"
                    }
                },
                "use_background_inside_header": {
                    "description": "Obecné - Používat obrázek pozadí i do hlavičky",
                    "hint": "Pokud není na stránce vybrán obrázek do hlavičky automaticky se do ní doplňí obrázek určený pro pozadí.",
                    "options": [
                        "Ne",
                        "Ano"
                    ]
                },
                "width": {
                    "description": "Obecné - Obrázek na pozadí",
                    "hint": "<p>Ovlivňuje jak se chová prostor vlevo a vpravo okolo samotného obsahu. Při pružném zobrazení je celý prostor vyplněn podkladovou barvou dané sekce (tzv. od kraje ke kraji). Při fixním zobrazení se dodatečný prostor vyplní úvodním obrázkem.</p><p><strong>Pozor</strong> - Rozdíl je patrný pouze na velkých, např. FullHD monitorech (rozlišení 1920px a vyšší).</p>",
                    "options": {
                        "fixed": "Ano",
                        "fluid": "Ne",
                        "semi-fixed": "",
                        "semi-fluid": ""
                    }
                }
            },
            "homepage": {
                "bouncing_button": {
                    "description": "Úvodní stránka - Neposedné tlačítko",
                    "hint": "Ovlivňuje zda se na homepage zobrazuje tzv. neposedné tlačítko, které upozorňuje návštěvníka, že úvodní stránka pokračuje směrem dolů. Tlačítko doporučujeme zapnout pokud máte na úvodní stránce dodatečný obsah, ideálně včetně fotografií.",
                    "options": [
                        "Ne",
                        "Ano"
                    ]
                },
                "content_position": {
                    "description": "Úvodní stránka - Umístění obsahu",
                    "hint": "Ovlivňuje pozici obsahu na úvodní stránce. Kvůli zajištění dobré čitelnosti je na hlavní fotku aplikován drobný tmavý přechod. Polohu uprostřed, kdy je přechod znatelnější, proto doporučujeme pouze pokud je vaše úvodní fotografie spíše tmavších odstínů.",
                    "options": {
                        "body": "Uprostřed",
                        "head": "Nahoře"
                    }
                },
                "header_height": {
                    "description": "Úvodní stránka - Výška hlavičky",
                    "options": {
                        "100": "100%",
                        "33": "33%",
                        "66": "66%",
                        "80": "80%"
                    }
                },
                "image": {
                    "description": "Obrázek na úvodní stránce"
                },
                "logo": {
                    "description": "Logo přímo na homepage",
                    "hint": "POZOR, logo přímo na homepage je pokročilé nastavení, které standartně nastavují pouze pracovníci z wistro.cz. Ne každé logo je pro tuto volbu vhodné."
                },
                "module": "Homepage",
                "quick_links": {
                    "description": "Úvodní stránka - Lišta s rychlými odkazy",
                    "options": {
                        "is-disabled": "Nezobrazovat",
                        "is-gradient": "Průhledná",
                        "is-transparent": "Poloprůhledná",
                        "is-white": "Bílá"
                    }
                },
                "show_blog": {
                    "description": "Zobrazovat blogové články na homepage"
                },
                "show_offer_boxes": {
                    "description": "Úvodní stránka - Dlaždice s nabídkou",
                    "hint": "Přidává na úvodní stránku velké dlaždice s odkazem na nabídku.",
                    "options": [
                        "Ne",
                        "Ano"
                    ]
                },
                "show_offer_link": {
                    "description": "Přidat odkaz na první lístek s nabídkou",
                    "options": [
                        "Ne",
                        "Ano"
                    ]
                },
                "show_opening_hours": {
                    "description": "Úvodní stránka - Zobrazit otevírací dobu",
                    "hint": "Zobrazí otevírací dobu na úvodní stránce.",
                    "options": [
                        "Ne",
                        "Ano"
                    ]
                },
                "show_slideshow": {
                    "description": "Úvodní stránka - Zobrazovat slideshow",
                    "options": [
                        "Ne",
                        "Ano"
                    ]
                },
                "show_title_lower": {
                    "description": "Zobrazit název podniku až pod hlavním obrázkem",
                    "hint": "Vhodné pro podniky, které mají na úvodní stránce umístěno vlastní logo s jasně čitelným názvem podniku"
                },
                "tagline": {
                    "description": "Úvodní věta o podniku"
                }
            },
            "lunch_menu": {
                "availability_enabled": {
                    "description": "Zobrazovat dostupnost"
                },
                "compact": {
                    "description": "Kompatkní zobrazení",
                    "hint": "Název kategorie se zobrazí na stejném řádku jako název pokrmu."
                },
                "enabled": {
                    "description": "Povolit obědové menu"
                },
                "label": {
                    "description": "Označení obědového menu na webu",
                    "hint": "Vyplňte pouze v případě, kdy chcete změnit výchozí označení z výrazu \"Obědově menu\" na jiný. Pozor dojde i ke změně URL adresy, na které je obědové menu dostupné."
                },
                "module": "Denní menu",
                "not_set_label": {
                    "description": "Věta zobrazená v případě, že denní menu není zadáno."
                },
                "packaging_enabled": {
                    "description": "Zobrazovat cenu za obal"
                },
                "pdf_text": {
                    "description": "Text, který je obsažen v patičce tiskového PDF poledního menu"
                },
                "show_allergens": {
                    "description": "Zobrazovat alergeny"
                },
                "show_empty_day": {
                    "description": "Zobrazovat i dny, pro které není zadaná nabídka",
                    "hint": "Zobrazení je vhodné vypnout pro podniky, které zadávají nabídku pouze jeden den dopředu"
                },
                "show_portion": {
                    "description": "Zobrazovat velikost porce"
                },
                "show_time": {
                    "description": "Zobrzovat čas podávání obědového menu"
                },
                "show_week": {
                    "description": "Zadávat týdenní nabídku"
                },
                "week_after_daily": {
                    "description": "Doplňovat týdenní nabídku za položky z denní nabídky"
                }
            },
            "orders": {
                "ordering_services_label": {
                    "description": "Objednávkové služby (vlastní text)"
                },
                "minimum_total_price": {
                    "description": "Minimální hodnota objednávky"
                },
                "minimum_group_total_price": {
                    "description": "Minimální hodnota objednávky v rámci jedné skupiny"
                },
                "disable_ordering": {
                    "description": "Zablokovat objednávání až do odvolání"
                },
                "lunch_days": {
                    "description": "Denní menu - Který den je možné přidávat do košíku",
                    "options": {
                        "today": "Aktuální den",
                        "this_week": "Aktuální týden (kromě aktuálního dne)",
                        "this_and_next_week": "Všechny dny (kromě aktuálního dne)"
                    }
                },
                "lunch_next_day_limit": {
                    "description": "Denní menu - Umožnit objednávky na následující den pouze do času"
                },
                "disable_ordering_until": {
                    "description": "Zablokovat objednávání až do zvoleného času"
                },
                "email": {
                    "description": "E-mail pro upozornění"
                },
                "enabled": {
                    "description": "Povolit modul"
                },
                "lunch_enabled": {
                    "description": "Povolit prodej denního menu"
                },
                "module": "Online prodej",
                "require_connected_panel": {
                    "description": "Zablokovat objednávání bez připojeného ovládacího panelu"
                },
                "sent_restaurant_notifications_emails": {
                    "description": "Odesílat do restaurace emailová upozornění na novou objedávku"
                },
                "time_restrictions_lunch": {
                    "description": "Umožnit objednávání obědového menu pouze v definovaném čase",
                    "hint": "Čas je možné definovat v sekci <strong>Otevírací doba</strong>"
                },
                "time_restrictions_offer": {
                    "description": "Umožnit objednávání ze stálé nabídky pouze v definovaném čase",
                    "hint": "Čas je možné definovat v sekci <strong>Otevírací doba</strong>"
                }
            },
            "reservation": {
                "days_from": {
                    "description": "Za kolik dní umožnit rezervovat"
                },
                "days_to": {
                    "description": "Na kolik dní umožnit rezervovat"
                },
                "email": {
                    "description": "E-mail pro upozornění"
                },
                "enabled": {
                    "description": "Povolit rezervace"
                },
                "max_persons": {
                    "description": "Maximální počet osob pro rezervaci"
                },
                "module": "Rezervace",
                "phone": {
                    "description": "Telefonní číslo"
                },
                "show_form": {
                    "description": "Zobrazovat rezervační formulář"
                },
                "time_from": {
                    "description": "Od kolika hodin je možné rezervovat"
                },
                "time_to": {
                    "description": "Do kolika hodin je možné rezervovat"
                }
            },
            "structured_data": {
                "address_country": {
                    "description": "Adresa (Stát)",
                    "hint": "Zadává se jako kód o 2 znacích dle <a href='https://en.wikipedia.org/wiki/ISO_3166-1' target='_blank'>https://en.wikipedia.org/wiki/ISO_3166-1</a>"
                },
                "address_locality": {
                    "description": "Adresa (Obec)"
                },
                "address_postal_code": {
                    "description": "Adresa (PSČ)",
                    "hint": "Zadává se bez mezer."
                },
                "module": "Strukturovaná data",
                "price_range": {
                    "description": "Cenová hladina",
                    "hint": "Typicky se využívá: <strong>$</strong>, <strong>$$</strong> nebo <strong>$$$</strong>. Lze však použít jakýkoliv text, který přiblíží cenovou hladinu restaurace."
                },
                "serves_cuisine": {
                    "description": "Podávaná kuchyně",
                    "hint": "Typ kuchyně, který restaurace podává. Např. česká, mezinárodní, atp."
                },
                "street_address": {
                    "description": "Adresa (Ulice)"
                }
            },
            "vouchers": {
                "email": {
                    "description": "E-mail pro upozornění"
                },
                "image": {
                    "description": "Ilustrační obrázek"
                },
                "enabled": {
                    "description": "Povolit dárkové poukazy"
                },
                "module": "Dárkové poukazy",
                "validity": {
                    "description": "Platnost voucheru (počet měsíců)"
                }
            },
            "web_payments": {
                "bank_account": {
                    "description": "Číslo bankovního účtu",
                    "hint": "Vkládejte kompletní číslo bankovního účtu, např.: <strong>670100-2204743278/6210</strong>"
                },
                "module": "Webové platby",
                "stripe_pk": {
                    "description": "Stripe - Publishable key",
                    "hint": "Zkontrlujte zda prefix vašeho klíče odpovidá formátu: <strong>pk_live_</strong>xxxxxxxxxxxxxxxxxxxxx"
                },
                "stripe_sk": {
                    "description": "Stripe - Secret key",
                    "hint": "Zkontrlujte zda prefix vašeho klíče odpovidá formátu: <strong>sk_live_</strong>xxxxxxxxxxxxxxxxxxxxx"
                },
                "stripe_webhook_secret": {
                    "description": "Stripe - Webhook secret",
                    "hint": "Nastavuje se automatizovaným procesem"
                }
            }
        },
        "vue": {
            "add": "Přidat",
            "addDate": "Přidat konkrétní datum",
            "back": "Zpět",
            "break": "Přerušení otevírací doby",
            "close": "Zavřít",
            "closed": "Zavřeno",
            "continue": "Pokračovat",
            "deleted": "Úspěšně odstraněno",
            "kitchen": "Provoz kuchyně",
            "lunchMenu": "Obědové menu",
            "noBreak": "Bez přerušení otevírací doby",
            "notServing": "Nepodává se",
            "notShown": "Nezobrazovat",
            "restaurant": "Restaurace",
            "save": "Uložit",
            "saved": "Úspěšně uloženo",
            "serving": "Podává se",
            "vouchers": {
                "deliveryEmail": "E-mail pro doručení",
                "email": "E-mail",
                "emailHelp": "Na tento e-mail vám odešleme dárkový poukaz.",
                "inscription": "Věnování",
                "inscriptionHelp": "Věnování je nepovinné.",
                "isOk": "Jsou údaje v pořádku?",
                "order": "Objednat",
                "pay": "Zaplatit",
                "paymentMethod": "Způsob platby",
                "paymentMethods": {
                    "bank_transfer": "Bankovním převodem",
                    "in_person": "Osobně v restauraci",
                    "stripe": "Kartou online",
                    "generated": "Generované v administraci"
                },
                "recapitulation": "Rekapitulace objednávky",
                "voucherValue": "Hodnota poukazu"
            },
            "sendReservation": "Odeslat rezervaci",
            "reservationForm": "Rezervační formulář",
            "message": "Zpráva",
            "Yes": "Ano",
            "No": "Ne",
            "newsletter": "Souhlasím se zasíláním marketingových sdělení"
        },
        "wistro": {
            "about_us": "O nás",
            "cookies": {
                "actions": {
                    "accept": "Přijmout",
                    "accept_all": "Přijmout všechny",
                    "accept_required": "Přijmout nezbytné",
                    "accept_selected": "Přijmout vybrané",
                    "adjust": "Přizpůsobit",
                    "hide_details": "Skrýt podrobnosti",
                    "show_details": "Zobrazit podrobnosti"
                },
                "additionalInfo": "<p>Uvedené společnosti dále s cookies nakládají v souladu s jejich smluvními podmínkami:</p>",
                "content": "<h3>Co jsou soubory cookie</h3>\n            <p>Soubory cookie jsou krátké textové soubory, které internetová stránka odešle do vašeho prohlížeče. Umožňují internetové stránce zaznamenat informace o vaší návštěvě, například zvolený jazyk a podobně. Následující návštěva stránek tak pro vás může být snazší a příjemnější. Soubory cookie jsou důležité, neboť bez nich by procházení sítě Internet bylo mnohem složitější. Soubory cookie umožňují lepší využití naší internetové stránky a přizpůsobení jejího obsahu vašim potřebám. Soubory cookie používá téměř každá internetová stránka na světě. Soubory cookie jsou užitečné, protože zvyšují uživatelskou přívětivost opakovaně navštívené internetové stránky.</p>\n            <h3>Druhy souborů cookies</h3>\n            <p>Relační (tedy dočasné) soubory cookie nám umožňují propojovat vaše jednotlivé aktivity po dobu prohlížení těchto internetových stránek. V okamžiku otevření okna vašeho prohlížeče se tyto soubory aktivují a deaktivují se po zavření okna vašeho prohlížeče. Relační cookies jsou dočasné a po zavření prohlížeče se všechny tyto soubory vymažou.</p>\n            <p>Trvalé soubory cookie nám pomáhají váš počítač identifikovat, jestliže opětovně navštívíte naši internetovou stránku. Další výhodou trvalých cookies je to, že nám umožňují přizpůsobit naše internetové stránky vašim potřebám.</p>\n            <h3>Využívání souborů cookie</h3>\n            <p>V souladu s ustanovením § 89 odst. 3 zák. č. 127/2005 Sb., o elektronických komunikacích, v účinném znění, si vás tímto dovolujeme informovat, že naše internetové stránky využívají pro svoji činnost soubory cookie, tedy vaše soubory cookie, včetně trvalých, zpracováváme.</p>\n <h3>Účel použití souborů cookie</h3>\n            <p>K analýze naší návštěvnosti využíváme soubory cookie. Informace o tom, jak náš web používáte, sdílíme se svými partnery působícími v oblasti sociálních médií, inzerce a analýz. Služby, které využíváme:</p>",
                "cookie_settings": "Nastavení cookies",
                "cookies": {
                    "XSRF_TOKEN": "Slouží k prevenci před CSRF/XSRF útoky.",
                    "_fbp": "Slouží k cílení zobrazovaní relevantních reklam na digitální platformě Facebook.",
                    "_ga": "Slouží k rozlišení uživatelů v rámci Google Analytics.",
                    "_gat": "Slouží k omezení počtu požadavků do Google Analytics.",
                    "_gid": "Slouží k rozlišení uživatelů v rámci Google Analytics.",
                    "cookies_consent": "Slouží k uložení vašeho nastavení cookies.",
                    "laravel_session": "Slouží k identifikaci stavu webové stránky."
                },
                "cookies_description": "Popis",
                "cookies_identifier": "Identifikátor",
                "description": "Informace o souborech a využití souborů cookie",
                "info": "Pro zajištění bezpečnosti a správného fungování stránek využíváme cookies.",
                "more": "Další informace o nakládání se <a href=\"{url}\" target=\"_blank\">soubory cookies <span class=\"icon\"><i class=\"fa fa-external-link-alt\"></i></span></a>",
                "not_used": "Nevyužíváme",
                "required": "Vyžadováno",
                "settings": "Nastavení",
                "title": "Soubory cookie",
                "types": {
                    "analytics": {
                        "description": "Tyto soubory cookies slouží k analýze využívání stránek.",
                        "name": "Analytické cookies"
                    },
                    "marketing": {
                        "description": "Tyto soubory slouží k cílení zobrazování relevantních reklam na jiných platformách.",
                        "name": "Reklamní cookies"
                    },
                    "required": {
                        "description": "Tyto soubory cookies jsou technicky nezbytné k správnému fungování stránek.",
                        "name": "Nezbytné cookies"
                    }
                }
            },
            "email": {
                "hello": "Dobrý den"
            },
            "installation": "Instalace",
            "installationInfo": "Informace o této instalaci",
            "operation": "Provoz",
            "vouchers": {
                "not_code": "toto není autorizační kód",
                "applyInstructions": "Jakmile do vaší restaurace přijde zákazník a prokáže se autorizačním kódem zkontrolujte kód, hodnotu a platnost dárkového poukazu v administraci a poté poukaz zneplatněte.",
                "conditions": {
                    "delivery": "Po úhradě vám bude poukaz doručen elektronicky na e-mailovou adresu.",
                    "extent": "Poukaz je možné uplatit pro konzumaci jídel a nápojů v naší restauraci.",
                    "validity": "{0}Poukaz je platný {months} měsíců od úhrady.|{1} Poukaz je platný 1 měsíc od úhrady.}|[2,4]Poukaz je platný {months} měsíce od úhrady.|[5,*]Poukaz je platný {months} měsíců od úhrady."
                },
                "generatedVoucher": "na vašem webu právě došlo k úhradě dárkového poukazu.",
                "prolongedVoucher": "na vašem webu právě došlo k prodloužení platnosti dárkového poukazu.",
                "infoInMail": "Instrukce pro úhradu najdete rovněž ve svém e-mailu.",
                "invalidVoucher": "Voucher již není platný.",
                "newOrder": "Nová objednávka",
                "newOrderNumber": "na vašem webu právě vznikla nová objednávka číslo: <strong>{number}</strong>.",
                "newVoucher": "právě jsme pro vás vygenerovali dárkový voucher.",
                "voucher_reminder": "protože se na Vás stále těšíme, dovolujeme si připomenout, že brzy končí platnost Vašeho dárkového poukazu.",
                "number": "Přiřadili jsme jí číslo <strong>{number}</strong>.",
                "orderConfirmation": "potvrzujeme vaši objednávku dárkového poukazu.",
                "paidVoucher": "Uhrazeno",
                "paymentInfo": "Instrukce pro úhradu",
                "paymentRedirect": "Probíhá přesměrování na platební bránu.",
                "paymentsInfo": {
                    "bankTransfer": {
                        "amount": "Částka",
                        "bankAccount": "Číslo účtu",
                        "how": "Objednávku prosím uhraďte bankovním převodem na náš účet.",
                        "restaurantInfo": "V následujícíh dnech zkontrolujte výpis z Vašeho bankovního účtu. Pokud dohledáte platbu se správným variabilním symbolem a částkou označte poté daný voucher v administraci za uhrazený. Voucher se poté zákazníkovi automaticky odešle.",
                        "variableSymbol": "Variabilní symbol"
                    },
                    "inPersonHow": "Objednávku prosím uhraďte přímo v resturaci s pomocí variabilního symbolu: <strong>{number}</strong>.",
                    "inPersonRestaurantInfo": "Jakmile do vaší restauarace přijde zákazník a bude chtít uhradit voucher s konkrétním variabilním symbolem, převezměte od něho peníze a v administraci označte daný voucher za uhrazený. Voucher se poté zákazníkovi automaticky odešle.",
                    "inPersonWhere": "Najdete nás během otevírací doby na adrese: <strong>{address}</strong>."
                },
                "pdfPerex": "na konzumaci jídel a nápojů v restauraci",
                "send": "Dárkový poukaz jsme vám odeslali na emailovu adresu.",
                "serviceInfo": "Obsluhu je nutné na platbu poukazem upozornit před vydáním účtenky. Při platbě se prosím prokažte vytisklým voucherem.",
                "stripeFailed": "Platba kartou se nezdařila.",
                "thankYou": "Děkujeme za vaši objednávku.",
                "thankYouNumber": "děkujeme za vaši objednávku číslo {number}.",
                "toUse": "Autorizační kód",
                "validVoucher": "Voucher je uhrazený a platný.",
                "validityEndsAt": "Dárkový poukaz lze využít pouze jednorázově a v plné výši. Hodnotu poukazu nelze směnit za hotovost. Poukaz je platný do&nbsp;{date}.",
                "voucher": "Dárkový poukaz",
                "vouchers": "Poukazy",
                "waitingForPayment": "Čekáme na přijetí platby.",
                "whatToDo": "Co je nyní nutné udělat"
            }
        },
        "panel": {
            "controlPanel": "Ovládací panel"
        },
        "reservation": {
            "back": "Zpět",
            "contact-info": "Kontaktní údaje",
            "continue": "Pokračovat",
            "date": "Datum",
            "details": "[2,4] <strong>{date}</strong> v <strong>{time}</strong> pro <strong>{persons}</strong> osoby na jméno <strong>{name}</strong>|[5,*] <strong>{date}</strong> v <strong>{time}</strong> pro <strong>{persons}</strong> osob na jméno <strong>{name}</strong>",
            "find-us": "Kde nás najdete?",
            "goodbye": "Hezký den",
            "hello": "Dobrý den",
            "manage-reservation": "Spravovat rezervaci",
            "name": "Jméno",
            "name-hint": "Na toto jméno vytvoříme rezervaci",
            "notAvailable": "Aktuálně není možné vytvářet rezervace online.",
            "note": "Poznámka",
            "persons": "Počet osob",
            "phone": "Telefon",
            "phone-reservation": "Rezervace přijímáme telefonicky na čísle <a href=\"tel:{phone}\">{phone}</a>.",
            "pre-confirmation-text": "Vaše rezervace nyní čeká na potvrzení. Jakmile se její stav změní, budeme vás o tom informovat na emailové adrese. Pokud je v restauraci právě špička, může nám vyřízení chvíli trvat. Děkujeme za pochopení.",
            "pre-reservation-text": "Stav vaší rezervace si budete moci kdykoli zkontrolovat pomocí odkazu, který vám pošleme na email. Pokud si přejete zadat rezervaci na jiný den nebo rezervovat stůl pro více osob, kontaktuje nás prosím telefonicky.",
            "reservation": "Rezervace",
            "reserve": "Rezervovat",
            "show-reservation": "Zobrazit rezervaci",
            "statuses": {
                "canceled": {
                    "notice": "Zrušeno",
                    "sentence": "Vaše rezervace byla právě zrušena",
                    "short": "Zrušená",
                    "subject": "Zrušení rezervace"
                },
                "confirmed": {
                    "notice": "Potvrzeno restaurací",
                    "sentence": "Vaše rezervace byla právě potvrzena",
                    "short": "Potvrzená",
                    "subject": "Potvzení rezervace"
                },
                "new": {
                    "notice": "Úspěšně odesláno",
                    "sentence": "právě jsme obdrželi vaši rezervaci",
                    "sentence-admin": "právě byla vytvořena nová rezervace",
                    "short": "Nová",
                    "subject": "Nová rezervace"
                }
            },
            "time": "Čas",
            "vue-details": ". | . | Rezervace na <strong>{date}</strong> v <strong>{time}</strong> pro <strong>{persons}</strong> osoby | Rezervace na <strong>{date}</strong> v <strong>{time}</strong> pro <strong>{persons}</strong> osob"
        },
        "admin": {
            "action": {
                "add": "Přidat",
                "choose": "Vybrat",
                "delete": "Odstranit",
                "edit": "Upravit",
                "show": "Zobrazit"
            },
            "bookmarks": {
                "placement": {
                    "footer": "Patička",
                    "header": "Hlavička"
                },
                "type": {
                    "link": "Odkaz",
                    "page": "Stránka"
                }
            },
            "buttons": {
                "fill": "Naplnit"
            },
            "categories": {
                "columns": {
                    "auto": "Automaticky",
                    "one": "Jeden",
                    "two": "Dva"
                }
            },
            "color": {
                "black": "Black",
                "danger": "Danger",
                "dark": "Dark",
                "info": "Info",
                "light": "Light",
                "link": "Link",
                "primary": "Primary",
                "success": "Success",
                "warning": "Warning",
                "white": "White"
            },
            "crud": {
                "exportPdf": "Export PDF",
                "lunchMenu": "Obědové menu"
            },
            "default": "výchozí",
            "display": {
                "accepted": "Přijímáme",
                "auto": "Automatické",
                "hidden": "Nezobrazovat",
                "not_accepted": "Nepřijímáme"
            },
            "entity": {
                "adminReservation": "Správa rezervací",
                "adminVouchers": "Správa poukazů",
                "blockedDays": "Blokace dnů",
                "blog": "Blog",
                "bookmark": "Záložky",
                "category": "Kategorie",
                "content": "Obsah",
                "contentBox": "Obsahové bloky",
                "currentWeek": "Tento týden",
                "decoration": "Dekorace",
                "gallery": "Galerie",
                "general": "Obecné",
                "help": "Nápověda",
                "homeButton": "Úvodní tlačítka",
                "icon": "Ikonky",
                "ingredient": "Ingredience",
                "ingredientGroup": "Skupiny ingrediencí",
                "integrations": "Integrace",
                "language": "Jazyky",
                "lunchFeed": "XML feedy",
                "lunchWeek": "Tento týden, Příští týden",
                "lunchmenu": "Obědové menu",
                "lunchmenuday": "Dny",
                "meal": "Položky",
                "news": "Novinky",
                "nextWeek": "Příští týden",
                "notification": "Notifikace",
                "offer": "Nabídka",
                "offerMeal": "Položky",
                "offerMenu": "Lístky",
                "onlineOrders": {
                    "deliveryTypes": "Dopravní metody",
                    "index": "Online prodej",
                    "orders": "Objednávky",
                    "paymentTypes": "Platební metody"
                },
                "openingHour": "Otevírací doba",
                "openingHourDate": "Konkrétní dny",
                "openingHourDay": "Dny v týdnu",
                "page": "Stránky",
                "partnerProgram": "Partnerský program",
                "payment": "Platby",
                "paymentMethod": "Platební metody",
                "paymentType": "Typy plateb",
                "reservation": "Rezervace",
                "service": "Služby",
                "setting": "Nastavení",
                "socialNetworks": "Sociální sítě",
                "tag": "Štítky",
                "voucherValues": "Hodnota poukazů",
                "vouchers": "Dárkové poukazy",
                "webPaymentMethod": "Webové platby"
            },
            "export": {
                "fontSize": "Velikost písma",
                "nextWeek": "Příští týden",
                "range": "Rozsah",
                "spacing": "Řádkování",
                "thisWeek": "Tento týden",
                "week": "Týden",
                "weekend": "Víkend",
                "workdays": "Všední dny"
            },
            "field": {
                "active": "Aktivní",
                "activeLanguage": "Aktivní jazyk",
                "address": "Adresa",
                "allergens": "Alergeny",
                "buttonTitle": "Text na tlačítku",
                "buttonUrl": "Odkaz",
                "category": "Kategorie",
                "childCategory": "Podřazená kategorie",
                "code": "Kód",
                "columns": "Počet sloupců",
                "content": "Obsah",
                "contentBox": "Obsahové bloky",
                "created_at": "Vytvořeno",
                "customer": "Zákazník",
                "date": "Datum",
                "dateFrom": "Platnost od",
                "dateTo": "Platnost do",
                "day": "Den",
                "description": "Popis",
                "display": "Zobrazení",
                "dontShowName": "Nezobrazovat název",
                "free_price": "Zdarma od ceny",
                "highlighted": "Zvýraznění",
                "icon": "Ikona",
                "icon_color": "Barva ikony",
                "id": "ID",
                "image": "Obrázek",
                "imageType": "Způsob zobrazení obrázku",
                "images": "Fotky",
                "internal": "Interní označení",
                "key": "Klíč",
                "kitchen": "Kuchyně",
                "language": "Jazyk",
                "link": "Odkaz",
                "lunch": "Oběd",
                "mealIcons": "Ikony",
                "mealNum": "Počet jídel",
                "mealTag": "Tag",
                "menickaCzType": "Typ kategorie pro XML feed menicka.cz",
                "menu": "Lístek",
                "message": "Zpráva",
                "module": "Modul",
                "name": "Název",
                "note": "Poznámka",
                "notificationOnClick": "Akce po kliknutí",
                "notificationType": "Typ notifikace",
                "notificationValidity": "Platnost zprávy",
                "offer": {
                    "text_above": "Textový obsah nad nabídkou",
                    "text_below": "Textový obsah pod nabídkou"
                },
                "offerAvailability": "Dostupnost nabídky",
                "offerMeals": {
                    "enabledOrders": "Povolit pro online prodej",
                    "enabledWeb": "Zobrazovat na webové stránce",
                    "soldOut": "Vyprodáno"
                },
                "offered": "Poskytováno",
                "onlineOrders": {
                    "deliveryType": "Doručovací metoda",
                    "firstname": "Jméno",
                    "lastname": "Příjmení",
                    "order": "Objednávka",
                    "orderItems": "Položky",
                    "paymentType": "Platební metoda",
                    "totalPrice": "Celková cena"
                },
                "open": "Otevřeno",
                "packagingPrice": "Cena (obal)",
                "parentCategory": "Nadřazená kategorie",
                "payed_at": "Uhrazeno",
                "person_name": "Jméno",
                "persons": "Počet osob",
                "phone": "Telefon",
                "placement": "Umístění",
                "portion": "Porce",
                "price": "Cena",
                "primary": "Primární",
                "primaryLanguage": "Primární jazyk",
                "reason": "Důvod",
                "response": "Odpověď",
                "restaurant": "Restaurace",
                "showInMenu": "Zobrazit v menu",
                "socialNetwork": "Sociální síť",
                "state": "Stav",
                "status": "Stav",
                "style": "Styl",
                "subtitle": "Podnadpis",
                "time": "Čas",
                "timeFrom": "Od",
                "timeTo": "Do",
                "title": "Nadpis",
                "title-image": "Ilustrační obrázek",
                "type": "Typ",
                "url": "URL adresa",
                "validFrom": "Platnost od",
                "validTo": "Platnost do",
                "validity": "Platnost",
                "value": "Hodnota",
                "variable_symbol": "Var. symbol"
            },
            "filter": {
                "category": "Kategorie",
                "date": "Datum",
                "gallery": "Galerie",
                "general": "Obecné",
                "module": "Modul"
            },
            "help": {
                "availableSettings": "Dostupná nastavení",
                "basicInfo": "Základní informace",
                "recommended": "doporučujeme",
                "set": "Nastavit"
            },
            "hint": {
                "activeLanguage": "",
                "dateTo": "Pokud není nastaveno datum má otevírací doba nekonečnou platnost. Datum můžete smazat pomocí ikony koše v kalendáři.",
                "internal": "Slouží pro identifikaci záznamu v administraci, na webu se nezobrazuje.",
                "menickaCzType": "Ignorujte pokud XML feed pro menicka.cz nevyužíváte.",
                "notificationContent": "Platné pouze pro akci po kliknutí \"Modal\".",
                "notificationLink": "Platné pouze pro akci po kliknutí \"Odkaz\".",
                "notificationOnClick": "\n<ul>\n    <li><b>Žádná</b> - Na notifikaci nelze kliknout.</li>\n    <li><b>Odkaz</b> - Návštěvník je přesměrován na daný odkaz. Notifikace bude navíc obsahovat ikonku odkazu.</li>\n    <li><b>Modal</b> - Otevře se modal okno s detailním obsahem. Notifikace bude navíc obsahovat ikonku kliknutí.</li>\n <li><b>Popup</b> - Stejné jako modal, ale okno se navíc automaticky otevře při první návštěvě.</li>\n</ul>",
                "notificationType": "\n<ul>\n    <li><b>Info</b> - Vhodné pro běžné provozní informace, zobrazuje se modrou barvou.</li>\n    <li><b>Úspěch</b> - Vhodné pro nové nabídky nebo události, zobrazuje se zelenou barvou.</li>\n    <li><b>Varování</b> - Vhodné pro důležité upozornění omezující provoz, zobrazuje se výraznou žlutou barvou.</li>\n</ul>",
                "offered": "Zda je služba restaurací poskytována.",
                "primaryLanguage": "Jazyková mutace administrace a výchozí jazyková mutace webu.<br /><strong>Pozor - nevhodným nastavením může webová aplikace přestat fungovat.</strong>",
                "reason": "Poznámka k otevírací době",
                "showInMenu": "Vypnutím skryjete celou položku na webu.",
                "type": "Typ záznamu mění barvu ikony",
                "validTo": "Pokud není nastaveno datum má menu nekonečnou platnost. Datum můžete smazat pomocí ikony koše v kalendáři.",
                "withoutName": "Pokud je zašktnuto místo názvu kategorie se zobrazí pouze číselné pořadí. Menu 1 / Menu 2 atp."
            },
            "imageType": {
                "contain": "Přizpůsobit velikost (obrázek se nikdy neořízne, ne vždy je však vyplněna celá plocha)",
                "cover": "Oříznout obrázek (obrázek vždy vyplní celou plochu, může však dojít k jeho oříznutí)"
            },
            "integrations": {
                "instagram": {
                    "description": "Přidává posledních 9 fotografií z vašeho Instagramu na úvodní stránku webu.",
                    "name": "Instagram Feed"
                },
                "prazskejrej": {
                    "description": "Přidává rezervační formulář z portálu Rejdilky (Pražskej Rej).",
                    "name": "Rejdilky rezervace"
                },
                "previo_reservation_plus": {
                    "description": "Přidává rezervační formulář Previo Reservation+ do záložek typu ubytování.",
                    "name": "Previo Reservation+"
                }
            },
            "lunchmenuday": {
                "column": {
                    "serving": "Podáváme menu"
                },
                "field": {
                    "serving": "Podáváme menu"
                },
                "hint": {
                    "reason": "Důvod proč se nepodává polední menu."
                }
            },
            "menickaCzType": {
                "jidlo": "Jídlo",
                "polevka": "Polévka"
            },
            "notificationOnClick": {
                "close": "Žádná",
                "link": "Odkaz",
                "modal": "Modal",
                "popup": "Popup"
            },
            "notificationType": {
                "is-info": "Info",
                "is-success": "Úspěch",
                "is-warning": "Varování"
            },
            "nums": {
                "items": "{0}Žádná položka|{1} {num} položka|[2,4]{num} položky|[5,*]{num} položek",
                "notifications": "{0}Žádná aktivní|{1} {num} aktivní notifikace|[2,4]{num} aktivní notifikace|[5,*]{num} aktivních notifikací",
                "reservations": "{0}Žádná nevyřízená rezervace|{1} {num} nová rezervace|[2,4]{num} nové rezervace|[5,*]{num} nových rezervací"
            },
            "offer": {
                "additional": "Doplňkové informace o vaší nabídce.",
                "hint": "Sem zadávajte vaši nabídku, tj. všechny jídla a nápoje."
            },
            "offerMeals": {
                "variant": "variantu",
                "variants": "Další varianty"
            },
            "operations": {
                "qrCode": "QR kód"
            },
            "options": {
                "active": [
                    "Neaktivní",
                    "Aktivní"
                ],
                "primary": [
                    "Ne",
                    "Ano"
                ]
            },
            "pages": {
                "blog": "Blog",
                "contact": "Kontakty",
                "homepage": "Homepage (Úvodní stránka)",
                "lunch_menu": "Obědové menu",
                "offer": "Nabídka",
                "reservation": "Rezervace",
                "vouchers": "Dárkové poukazy"
            },
            "reservation": {
                "actions": {
                    "cancel": "Zrušit rezervaci",
                    "confirm": "Potvrdit rezervaci"
                },
                "notifications": {
                    "canceled": "Rezervace byla zrušena",
                    "confirmed": "Rezervace byla potvrezena"
                },
                "sendEmail": "Odeslat zákazníkovi e-mail s notifikací"
            },
            "sample": {
                "customiseDesign": "Přizpůsobte si vzhled vaší instalace",
                "firstTime": "Jste tu poprvé?",
                "showInfo": "Zobrazit"
            },
            "show-website": "Zobrazit stránky",
            "state": {
                "hidden": "Skryté"
            },
            "validSettings": "Platné nastavení",
            "vouchers": {
                "appliedSuccess": "Poukaz byl aplikován.",
                "apply": "Zneplatnit",
                "pay": "Uhradit",
                "payedSuccess": "Poukaz byl uhrazen."
            },
            "webPaymentMethod": {
                "bank_transfer": "Bankovním převodem",
                "in_person": "Osobně v restauraci",
                "stripe": "Stripe - Kartou online",
                "generated": "Generované v administraci"
            },
            "webPaymentMethodHint": {
                "bank_transfer": "V nastavení webových plateb musí být vyplněno číslo bankovního účtu.",
                "in_person": "V nastavení kontaktních údajů musí být vyplněna adresa.",
                "stripe": "V nastavení webových plateb musí být vyplněny ostré Stripe API klíče.",
                "generated": "Tato platební metoda zpřístupňuje generování poukazů přímo z administrace."
            }
        },
        "orders": {
            "actions": {
                "addMoreItems": "Přidat další položky",
                "addNote": "Přidat poznámku",
                "back": "Zpět",
                "backMoreItems": "Zpět k výběru položek",
                "manage": "Spravovat objednávku",
                "order": "Objednat",
                "orderOnline": "Objednat online",
                "removeNote": "Odstranit poznámku",
                "show": "Zobrazit objednávku"
            },
            "address": "Adresa",
            "cart": "Nákupní košík",
            "cartContent": "Obsah košíku",
            "customer": "Zákazník",
            "delivery": "Doručení",
            "deliveryAddress": "Adresa pro doručení",
            "deliveryType": "Způsob doručení",
            "deliveryTypes": {
                "delivery": "Rozvoz",
                "takeaway": "Osobní odběr",
                "long_term": "Pravidelný rozvoz"
            },
            "email": "E-mail",
            "firstname": "Jméno",
            "lastname": "Příjmení",
            "mail": {
                "stateChange": "právě se změnil stav vaší objednávky.",
                "states": {
                    "CANCELLED": {
                        "state": "Vaše objednávka byla zrušena.",
                        "title": "Storno objednávky číslo {number}"
                    },
                    "CONFIRMED": {
                        "state": "Obsluha zaznamenala vaši objednávku.",
                        "title": "Obsluha zaznamenala objednávku číslo {number}"
                    },
                    "NEW": {
                        "state": "Vaše objednávka byla vytvořena.",
                        "title": "Vytvořena objednávka číslo {number}"
                    },
                    "ON_DELIVERY": {
                        "state": "Jídlo je na cestě.",
                        "title": "Jídlo je na cestě - Objednávka číslo {number}"
                    },
                    "PENDING_PAYMENT": {
                        "state": "Vaše objednávka čeká na úhradu.",
                        "title": "Výzva k úhradě objednávky číslo {number}"
                    },
                    "READY_TO_PICKUP": {
                        "state": "Jídlo je připraveno k vyzvednutí.",
                        "title": "Připraveno k vyzvednutí - Objednávka číslo {number}"
                    },
                    "restaurant_NEW": {
                        "state": "Máte novou online objednávku.",
                        "title": "Nová online objednávka číslo {number}"
                    }
                }
            },
            "method": "Způsob",
            "note": "Poznámka",
            "order": "Objednávka",
            "orderNum": "Číslo objednávky",
            "orderNumber": "Objednávka číslo {number}",
            "orderOnline": "Objednat online",
            "ordering": {
                "active": "Objednávání je aktivní",
                "paused": "Objednávání je pozastaveno"
            },
            "orders": "Objednávky",
            "packaging": "Obaly",
            "paidAt": "Uhrazeno",
            "payment": "Platba",
            "paymentAndDelivery": "Doručení a platba",
            "paymentType": "Způsob platby",
            "paymentTypes": {
                "card_on_delivery": "Kartou při předání",
                "cash": "Hotově",
                "meal_vouchers": "Stravenkami",
                "online_stripe": "Kartou online",
                "invoice": "Na fakturu"
            },
            "phone": "Telefon",
            "state": "Stav",
            "states": {
                "CANCELLED": "Zrušená",
                "CLOSED": "Uzavřená",
                "CONFIRMED": "Potvrzená",
                "CREATING": "Vznikající",
                "NEW": "Nová",
                "ON_DELIVERY": "Na cestě",
                "PAYMENT_PENDING": "Čeká na úhradu",
                "READY_TO_DELIVERY": "Připraveno k dopravě",
                "READY_TO_PICKUP": "Připraveno k vyzvednutí"
            },
            "stripe": {
                "canceled": "Online platba kartou se nezdařila.",
                "paymentRedirect": "Probíhá přesměrování na platební bránu..."
            },
            "total": "Celkem",
            "zeroItems": "Košík je prázdný"
        }
    },
    "de": {
        "datetime": {
            "days": {
                "1": "Montag",
                "2": "Dienstag",
                "3": "Mittwoch",
                "4": "Donnerstag",
                "5": "Freitag",
                "6": "Samstag",
                "7": "Sonntag",
                "8": "Feiertag"
            },
            "daysShort": {
                "1": "Mo",
                "2": "Di",
                "3": "Mi",
                "4": "Do",
                "5": "Fr",
                "6": "Sa",
                "7": "So",
                "8": "Fe"
            },
            "from": "von",
            "nextWeek": "Nächste Woche",
            "thisWeek": "Diese Woche",
            "today": "Heute",
            "tomorrow": "Morgen",
            "until": "zu"
        },
        "settings": {
            "contact": {
                "address": {
                    "description": "Adresse des Restaurants",
                    "hint": "Adresse wird nicht nur für die Kunden verwendet werden, sondern auch die Lage auf Google Maps zu finden."
                },
                "email": {
                    "description": "E-Mail"
                },
                "ic": {
                    "description": "Identifizierungsnummer"
                },
                "info": {
                    "description": "Weitere Informationen über Kontaktseite"
                },
                "module": "Impressum",
                "name": {
                    "description": "Restaurant-Name (Dies wird auf der Website angezeigt)"
                },
                "operator": {
                    "description": "Comapny, die das Restaurant betreibt"
                },
                "phone": {
                    "description": "Telefonnummer"
                },
                "show_email": {
                    "description": ""
                },
                "show_kitchen": {
                    "description": "Anzeigen Öffnungszeiten der Küche"
                }
            },
            "cta": {
                "custom_style": {
                    "description": "",
                    "hint": "",
                    "options": {
                        "black": "",
                        "blue": "",
                        "danger": "",
                        "success": "",
                        "warning": "",
                        "white": ""
                    }
                },
                "custom_text": {
                    "description": "",
                    "hint": ""
                },
                "custom_url": {
                    "description": "",
                    "hint": ""
                },
                "module": "",
                "type": {
                    "description": "",
                    "options": {
                        "contact": "",
                        "custom": "",
                        "none": "",
                        "order_online": "",
                        "phone": "",
                        "table_reservation": ""
                    }
                }
            },
            "external": {
                "facebook_pixel": {
                    "description": "Facebook Pixel",
                    "hint": "Legen Sie einfach die Tracking-ID, zB .: <strong> 926140414437894 </ strong>"
                },
                "google_analytics": {
                    "description": "Google Analytics",
                    "hint": "Legen Sie einfach die Tracking-ID, zB .: <strong> UA-123456789-3 </ strong>"
                },
                "google_analytics_4": {
                    "description": "",
                    "hint": ""
                },
                "google_tag_manager": {
                    "description": "",
                    "hint": ""
                },
                "module": "Tracking-Codes"
            },
            "font": {
                "display": {
                    "description": "",
                    "options": {
                        "alice": "",
                        "blink-mac": "",
                        "caveat": "",
                        "comfortaa": "",
                        "cormorant-infant": "",
                        "cormorant-sc": "",
                        "eb-garamond": "",
                        "lobster": "",
                        "lora": "",
                        "merriweather": "",
                        "montserrat": "",
                        "overpass": "",
                        "pacificio": "",
                        "palanquin-dark": "",
                        "playfair-display": "",
                        "prata": "",
                        "pt-sans": "",
                        "roboto": "",
                        "ubuntu": "",
                        "yeseva-one": ""
                    }
                },
                "module": "",
                "text": {
                    "description": "",
                    "options": {
                        "blink-mac": "",
                        "lora": "",
                        "merriweather": "",
                        "montserrat": "",
                        "open-sans": "",
                        "raleway": "",
                        "roboto": "",
                        "ubuntu": ""
                    }
                }
            },
            "gallery": {
                "label": {
                    "description": "Galerieaufkleber",
                    "hint": "Füllen Sie nur, wenn Sie die Standard „Galerie“ Label ändern möchten."
                },
                "module": "Galerie",
                "thumbnail": {
                    "description": "Typ von Thumbnails innerhalb Galerie",
                    "hint": "<Strong> Abdeckung </ strong> (default) - geeignet, wenn die meisten Fotos sind im Querformat - die Bilder werden jedoch abgeschnitten werden, jedes Bild wird ähnlich sieht <br /> <strong> fit </ strong> - geeignet wenn die Fotos Format nicht ähnlich oder die meisten von ihnen sind im Hochformat",
                    "options": {
                        "cover": "",
                        "fit": ""
                    }
                }
            },
            "general": {
                "background_image": {
                    "description": "Allgemein - Hintergrundbild",
                    "hint": "Das Bild, das im Hintergrund (sichtbar, es sei denn natürlich, stellen Sie eine feste Ansicht oder wenn es als ein Bild in der Kopfzeile freigegeben) verwendet wird."
                },
                "box": {
                    "description": "",
                    "options": {
                        "heavy": "",
                        "lite": "",
                        "relief": "",
                        "shadow": "",
                        "smooth": ""
                    }
                },
                "floated_logo": {
                    "description": "Schwimmdock logo",
                    "hint": "eine erweiterte Einstellungen Option verwendbar nur mit entsprechenden Daten Warnung, wird das Logo schwimmt."
                },
                "footer_style": {
                    "description": "Footer Farbe",
                    "hint": "Ändert Fußzeile Farbe der Website.",
                    "options": {
                        "black": "Schwarz",
                        "dark": "Dunkel",
                        "light": "Licht",
                        "white": "Weiß"
                    }
                },
                "logo": {
                    "description": "Restaurant logo"
                },
                "logo_dark": {
                    "description": "Allgemein - Dark Restaurant logo",
                    "hint": "Um auf hellem Hintergrund verwendet werden."
                },
                "logo_light": {
                    "description": "Allgemein - Licht Restaurant logo",
                    "hint": "Um auf dunklem Hintergrund verwendet werden."
                },
                "logo_pdf": {
                    "description": "Restaurant Logo für PDF-Exporte"
                },
                "module": "Design",
                "nav_bar_shadow": {
                    "description": "Shadowing der Hauptnavigationsleiste",
                    "options": {
                        "shadow-heavy": "schwer",
                        "shadow-light": "Licht",
                        "shadow-none": "ohne Schatten"
                    }
                },
                "nav_bar_size": {
                    "description": "Größe der Haupt-Navigationsleiste",
                    "hint": "Ovlivňuje jak velkou část obrazovky bude hlavní Navigační lišta zabírat.",
                    "options": {
                        "is-large": "Groß",
                        "is-medium": "Mittel",
                        "is-small": "Klein"
                    }
                },
                "navbar_logo_size": {
                    "description": "",
                    "hint": "",
                    "options": {
                        "default": "",
                        "float": "",
                        "full": ""
                    }
                },
                "navigation_content_position": {
                    "description": "",
                    "options": {
                        "center": "",
                        "left": "",
                        "right": "",
                        "split": ""
                    }
                },
                "navigation_highlight": {
                    "description": "Navbar Link-Hervorhebung Verfahren",
                    "hint": "Ovlivňuje jakým způsobem se zvýrazní nur darauf warten aktivní položka v Navigační Liste ein položka na kterou Návštěvník najede Myší.",
                    "options": {
                        "has-highlight-background": "Hintergrund",
                        "has-highlight-color": "Farbton",
                        "has-highlight-underline": "Unterstreichen"
                    }
                },
                "navigation_transparent": {
                    "description": "Navbar - Opazität",
                    "hint": "Es wirkt sich, ob die Navigationsleiste in der Ausgangsstellung transparent. Transparente Navigationsleiste erscheint nur, wenn es auf dem Seitenkopf Hintergrundbild ist. Die Einstellung ist ebenfalls verfügbar und Auswahl durch die es möglich ist ein Hintergrundbild global auf alle Standorte hinzuzufügen.",
                    "options": [
                        "Nein",
                        "Ja"
                    ]
                },
                "navigation_width": {
                    "description": "",
                    "options": {
                        "fixed": "",
                        "fluid": ""
                    }
                },
                "notifications_above_navigation": {
                    "description": "Allgemein - Mitteilung Stellung",
                    "hint": "Er beeinflusst die schnelle Benachrichtigung (Notifikation) zobrazají oberhalb oder unterhalb der Navigationsleiste.",
                    "options": [
                        "über navbar",
                        "unter navbar"
                    ]
                },
                "padding": {
                    "description": "",
                    "options": {
                        "large": "",
                        "medium": "",
                        "small": ""
                    }
                },
                "primary_color": {
                    "description": "Primärfarbe",
                    "hint": "Ovlivňuje barvu hlavní Navigační lišty ein tlačítka pro Rychlý přechod tun nabídky jídel.",
                    "options": {
                        "black": "Schwarz",
                        "blue": "Blau",
                        "brown": "Braun",
                        "dark": "Dunkel",
                        "green": "Grün",
                        "light": "Licht",
                        "red": "rot",
                        "white": "Weiß",
                        "yellow": "Gelb"
                    }
                },
                "secondary_color": {
                    "description": "Sekundäre Farbe",
                    "hint": "Ovlivňuje barvu většiny nadpisů, šípky pro rychlé vyrolování webu nahoru ein podkladovou barvu pro zvýrazněné Kategorie jídelního lístku. Rozdíly v barvě nadpisů mohou být u některých Temat vzhledem k tloušťce pisem velmi Jemné.",
                    "options": {
                        "black": "Schwarz",
                        "blue": "Blau",
                        "brown": "Braun",
                        "dark": "Dunkel",
                        "green": "Grün",
                        "red": "rot"
                    }
                },
                "social_accounts_style": {
                    "description": "Social-Konten Symbole Stil",
                    "hint": "Ändert die Darstellung der Symbole der sozialen Konten.",
                    "options": {
                        "round-bw": "Schwarz-Weiß-Kreis",
                        "round-color": "Farbige Kreis",
                        "square-bw": "Schwarz-Weiß-Quadrat",
                        "square-color": "Farbige Quadrat"
                    }
                },
                "theme": {
                    "description": "WISTRO Thema",
                    "hint": "Jemné ovlivňuje většinu prvků celého webu, tj. napríklad písma, odstíny, přechody, tlačítka ein významněji potom hlavní Navigační listu. Volba WISTRO Tematu je Ciste pocitová záležitost.",
                    "options": {
                        "cerulean": "zweckhaft",
                        "default": "Bulma",
                        "lumen": "Lumen",
                        "putty": "Kitt",
                        "sandstone": "Sandstein"
                    }
                },
                "title_size": {
                    "description": "Größe des Titels",
                    "hint": "Ovlivňuje velikost plochy pro hlavní nadpisy na jednotlivých stránkách.",
                    "options": {
                        "is-large": "groß",
                        "is-larger": "größere",
                        "is-largest": "Größten",
                        "is-medium": "Mittel",
                        "is-small": "Klein"
                    }
                },
                "use_background_inside_header": {
                    "description": "Allgemein - Verwenden Sie Hintergrundbild im Header",
                    "hint": "Wenn es nicht auf das ausgewählte Bild automatisch Kopf ist ihr Bild zu ergänzen, die für Hintergrund.",
                    "options": [
                        "Nein",
                        "Ja"
                    ]
                },
                "width": {
                    "description": "Layoutbreite",
                    "hint": "<p>Es beeinflusst, wie verhält es Raum links und rechts um die Inhalte selbst. Wenn die flexible Anzeige, wird der gesamte Raum mit Hintergrundfarbe des Abschnitts gefüllt (dh. Von Kante zu Kante). Mit einem festen Anzeige zusätzlichen Raum füllt Öffnen Bild </p> <p> <strong> Warnung </strong> - Ist der Unterschied bemerkbar nur bei großen, zum Beispiel FullHD-Monitore (Auflösung 1920px und höher) </p>",
                    "options": {
                        "fixed": "Fest",
                        "fluid": "Flüssigkeit",
                        "semi-fixed": "Geregelt mit Flüssigkeit navbar",
                        "semi-fluid": "Fluid mit fester navbar"
                    }
                }
            },
            "homepage": {
                "bouncing_button": {
                    "description": "bouncing Taste",
                    "hint": "Ovlivňuje zda se na Homepage zu tzv. neposedné tlačítko, které upozorňuje návštěvníka, že úvodní stránka pokračuje směrem dolů. Tlačítko doporučujeme orden zapnout pokud máte na úvodní stránce dodatečný obsah, idealne včetně fotografií.",
                    "options": [
                        "Nein",
                        "Ja"
                    ]
                },
                "content_position": {
                    "description": "Homepage Inhalt Position",
                    "hint": "Beeinflusst die Position des Inhalts auf der Homepage. Um eine gute Lesbarkeit zu dem Hauptbild kleinen dunklen Übergang angelegt wird. Lage in der Mitte, wenn der Übergang bemerkbar, so dass es nur dann, wenn Ihre ursprüngliche Bild eher dunkleren Schattierungen empfohlen.",
                    "options": {
                        "body": "Mitte",
                        "head": "oben"
                    }
                },
                "header_height": {
                    "description": "",
                    "options": {
                        "100": "",
                        "33": "",
                        "66": "",
                        "80": ""
                    }
                },
                "image": {
                    "description": "Bild auf der Startseite"
                },
                "logo": {
                    "description": "Logo auf der Homepage",
                    "hint": "Achtung, dies ist eine erweiterte Einstellungen Option verwendbar nur mit entsprechenden Daten."
                },
                "module": "Startseite",
                "quick_links": {
                    "description": "",
                    "options": {
                        "is-disabled": "",
                        "is-gradient": "",
                        "is-transparent": "",
                        "is-white": ""
                    }
                },
                "show_blog": {
                    "description": "Blogartikel auf Homepage anzeigen"
                },
                "show_offer_boxes": {
                    "description": "Homepage - offer tiles",
                    "hint": "Adds large offer tiles to homepage.",
                    "options": [
                        "Nein",
                        "Ja"
                    ]
                },
                "show_offer_link": {
                    "description": "Anzeigen Link auf erste Angebot Karte",
                    "options": [
                        "Nein",
                        "Ja"
                    ]
                },
                "show_opening_hours": {
                    "description": "Anzeigen Öffnungszeiten auf der Homepage",
                    "hint": "Shows opening hours on homepage.",
                    "options": [
                        "Nein",
                        "Ja"
                    ]
                },
                "show_slideshow": {
                    "description": "",
                    "options": [
                        "",
                        ""
                    ]
                },
                "show_title_lower": {
                    "description": "Show restaurant name below main picture",
                    "hint": "Vhodné pro podniky, které mají na úvodní stránce umístěno vlastní logo s jasně čitelným názvem podniku"
                },
                "tagline": {
                    "description": "Hauptanmerkung"
                }
            },
            "lunch_menu": {
                "availability_enabled": {
                    "description": ""
                },
                "compact": {
                    "description": "Kompaktansicht",
                    "hint": "Name der Kategorie auf der gleichen Zeile wie Mahlzeit Name"
                },
                "enabled": {
                    "description": "Aktivieren Mittagsmenü"
                },
                "label": {
                    "description": "Mittags Menü Etikett",
                    "hint": "Geben Sie nur, wenn Sie maßgeschneiderte wollen den Text auf Lunch-Menü verwendet, beachten Sie, dass URL-Adresse wird auch ändern."
                },
                "module": "Mittagsmenü",
                "not_set_label": {
                    "description": ""
                },
                "packaging_enabled": {
                    "description": ""
                },
                "pdf_text": {
                    "description": "Text, der auf Mittagsmenü Druck PDFs hinzugefügt wird."
                },
                "show_allergens": {
                    "description": "anzeigen Allergenen"
                },
                "show_empty_day": {
                    "description": "Zobrazovat i dny, pro které není zadaná nabídka",
                    "hint": "Zobrazení je vhodné vypnout pro podniky, které zadávají nabídku pouze jeden den dopředu"
                },
                "show_portion": {
                    "description": "Zeigen Sie Größe des Abschnitts"
                },
                "show_time": {
                    "description": "Zeigen Sie die Mittagszeit zum Servieren Zeit"
                },
                "show_week": {
                    "description": "Fill Woche Menü"
                },
                "week_after_daily": {
                    "description": "In Woche Menü nach Tagesmenü"
                }
            },
            "orders": {
                "disable_ordering": {
                    "description": ""
                },
                "disable_ordering_until": {
                    "description": ""
                },
                "email": {
                    "description": ""
                },
                "enabled": {
                    "description": ""
                },
                "lunch_enabled": {
                    "description": ""
                },
                "module": "",
                "require_connected_panel": {
                    "description": ""
                },
                "sent_restaurant_notifications_emails": {
                    "description": ""
                },
                "time_restrictions_lunch": {
                    "description": "",
                    "hint": ""
                },
                "time_restrictions_offer": {
                    "description": "",
                    "hint": ""
                }
            },
            "reservation": {
                "days_from": {
                    "description": "Lassen Sie Reservierungen, nach wie vielen Tagen"
                },
                "days_to": {
                    "description": "Lassen Sie Reservierungen für wie viele Tage"
                },
                "email": {
                    "description": "E-Mail-Benachrichtigungen für"
                },
                "enabled": {
                    "description": "Lassen Sie Reservierungen"
                },
                "max_persons": {
                    "description": "Maximale Anzahl der Personen reservieren"
                },
                "module": "Reservierung",
                "phone": {
                    "description": "Telefonnummer"
                },
                "show_form": {
                    "description": ""
                },
                "time_from": {
                    "description": "Von wann Reservierungen erlaubt"
                },
                "time_to": {
                    "description": "Bis zu welchem ​​Zeitpunkt Reservierungen erlaubt"
                }
            },
            "structured_data": {
                "address_country": {
                    "description": "",
                    "hint": ""
                },
                "address_locality": {
                    "description": ""
                },
                "address_postal_code": {
                    "description": "",
                    "hint": ""
                },
                "module": "",
                "price_range": {
                    "description": "",
                    "hint": ""
                },
                "serves_cuisine": {
                    "description": "",
                    "hint": ""
                },
                "street_address": {
                    "description": ""
                }
            },
            "vouchers": {
                "email": {
                    "description": "E-Mail-Benachrichtigungen für"
                },
                "enabled": {
                    "description": "Aktivieren Sie Geschenkgutscheine"
                },
                "module": "Geschenkgutschein",
                "validity": {
                    "description": "Geschenkgutscheine Gültigkeit Länge in Monaten"
                }
            },
            "web_payments": {
                "bank_account": {
                    "description": "Kontonummer",
                    "hint": "Geben Sie die vollständige Kontonummer, z.B .: <strong> 670100-2204743278 / 6210 </ strong>"
                },
                "module": "Web Zahlungen",
                "stripe_pk": {
                    "description": "Stripe - Veröffentlichbar Schlüssel",
                    "hint": "Stellen Sie sicher, dass die Vorwahl Ihres Schlüssels ist gleich: <strong> pk_live _ </ strong> xxxxxxxxxxxxxxxxxxxxx"
                },
                "stripe_sk": {
                    "description": "Stripe - Geheime Schlüssel",
                    "hint": "Stellen Sie sicher, dass die Vorwahl Ihres Schlüssels ist gleich: <strong> sk_live _ </ strong> xxxxxxxxxxxxxxxxxxxxx"
                }
            }
        },
        "vue": {
            "add": "Hinzufügen",
            "addDate": "In bestimmtes Datum",
            "back": "Zurück",
            "break": "Přerušení otevírací doby",
            "close": "Schließen",
            "closed": "Geschlossen",
            "continue": "Fortsetzen",
            "deleted": "Gelöscht",
            "kitchen": "Küchen Stunden",
            "lunchMenu": "Mittagsmenü",
            "noBreak": "Bez přerušení otevírací doby",
            "notServing": "nicht dient",
            "notShown": "Zeige nicht",
            "restaurant": "Restaurant",
            "save": "speichern",
            "saved": "Erfolgreich gespeichert",
            "serving": "Portion",
            "vouchers": {
                "deliveryEmail": "E-Mail",
                "email": "E-Mail",
                "emailHelp": "Sie bekommen den Gutschein an diese E-Mail-Adresse zugeschickt.",
                "inscription": "Widmung",
                "inscriptionHelp": "Widmung ist freiwillig.",
                "isOk": "Sind alle Daten korrekt?",
                "order": "Bestellen",
                "pay": "Zahlen",
                "paymentMethod": "Zahlungsmethode",
                "paymentMethods": {
                    "bank_transfer": "Banküberweisung",
                    "in_person": "Persönlich vor Ort",
                    "stripe": "Onlinezahlung"
                },
                "recapitulation": "Zusammenfassung",
                "voucherValue": "Gutscheinwert"
            },
            "Yes": "Ja",
            "No": "Nein",
            "newsletter": "Ich stimme dem Erhalt von marketing Mitteilungen zu"
        },
        "wistro": {
            "about_us": "Über uns",
            "cookies": {
                "actions": {
                    "accept": "Akzeptieren",
                    "accept_all": "Alle akzeptieren",
                    "accept_required": "Akzeptieren obligatorisch",
                    "accept_selected": "Ausgewählte akzeptieren",
                    "adjust": "Einstellen",
                    "hide_details": "Details ausblenden",
                    "show_details": "Details zeige"
                },
                "additionalInfo": "<p>Zustimmung zur Verwendung von Cookies</p>",
                "content": "<h3>Was sind Cookies?</h3>\n<p>Cookies sind kurze Textdateien, die eine Website an Ihren Browser sendet. Sie ermöglichen es der Website, Informationen über Ihren Besuch aufzuzeichnen, z. B. die von Ihnen gewählte Sprache usw. Der nächste Besuch der Website kann für Sie einfacher und angenehmer sein. Cookies sind wichtig, denn ohne sie wäre das Surfen im Internet viel schwieriger. Cookies ermöglichen es Ihnen, unsere Website besser zu nutzen und deren Inhalt an Ihre Bedürfnisse anzupassen. Cookies werden von fast jeder Website der Welt verwendet. Cookies sind nützlich, weil sie die Benutzerfreundlichkeit von wiederholt besuchten Websites erhöhen.</p>\n<h3>Arten von Cookies</h3>\n<p>Relationale (dh temporäre) Cookies ermöglichen es uns, Ihre individuellen Aktivitäten beim Surfen auf dieser Website zu verknüpfen. Diese Dateien werden beim Öffnen Ihres Browserfensters aktiviert und beim Schließen Ihres Browserfensters deaktiviert. Relationale Cookies sind temporär und alle diese Dateien werden gelöscht, wenn Sie den Browser schließen.</p>\n<p>Dauerhafte Cookies helfen uns, Ihren Computer zu identifizieren, wenn Sie unsere Website erneut besuchen. Ein weiterer Vorteil von dauerhaften Cookies besteht darin, dass sie es uns ermöglichen, unsere Website an Ihre Bedürfnisse anzupassen.</p>\n<h3>Verwendung von Cookies</h3>\n<p>Gemäß den Bestimmungen des § 89 Abs. 3 des Gesetzes Nr. 1 des Gesetzes. Nr. 127/2005 Slg., über elektronische Kommunikation, in der jeweils gültigen Fassung, möchten wir Sie darüber informieren, dass unsere Website Cookies für ihre Aktivitäten verwendet, dh wir verarbeiten Ihre Cookies, einschließlich dauerhafter Cookies.</p>\n<h3>Zweck der Verwendung von Cookies</h3>\n<p>Wir verwenden Cookies, um unseren Datenverkehr zu analysieren. Durch die Nutzung der Website stimmen Sie der Verbindung der folgenden Dienste zu:</p>",
                "cookie_settings": "Cookie-Einstellungen",
                "cookies": {
                    "XSRF_TOKEN": "Slouží k prevenci před CSRF/XSRF útoky.",
                    "_fbp": "Slouží k cílení zobrazovaní relevantních reklam na digitální platformě Facebook.",
                    "_ga": "Slouží k rozlišení uživatelů v rámci Google Analytics.",
                    "_gat": "Slouží k omezení počtu požadavků do Google Analytics.",
                    "_gid": "Slouží k rozlišení uživatelů v rámci Google Analytics.",
                    "cookies_consent": "Slouží k uložení vašeho nastavení cookies.",
                    "laravel_session": "Slouží k identifikaci stavu webové stránky."
                },
                "cookies_description": "Beschreibung",
                "cookies_identifier": "Kennung",
                "description": "Information about files and the use of cookies",
                "info": "Wir verwenden Cookies, um die Sicherheit und das ordnungsgemäße Funktionieren der Website zu gewährleisten.",
                "more": "Learn more about handling <a href=\"{url}\" target=\"_blank\"> cookies <span class=\"icon\"> <i class=\"fa fa-external-link-alt\"> </i> </ span> </a>",
                "not_used": "Nicht benutzt",
                "required": "Verpflichtend",
                "settings": "Einstellungen",
                "title": "Cookies Files",
                "types": {
                    "analytics": {
                        "description": "Diese Cookies werden verwendet, um die Nutzung der Website zu analysieren.",
                        "name": "Analytische Cookies"
                    },
                    "marketing": {
                        "description": "Verwenden Sie diese Dateien, um relevante Anzeigen auf andere Plattformen auszurichten.",
                        "name": "Marketing Cookies"
                    },
                    "required": {
                        "description": "Diese Cookies sind für das ordnungsgemäße Funktionieren der Website technisch erforderlich.",
                        "name": "Obligatorische Cookies"
                    }
                }
            },
            "email": {
                "hello": "Guten Tag"
            },
            "installation": "Installation",
            "installationInfo": "Informationen zu dieser Installation",
            "operation": "Operation",
            "vouchers": {
                "applyInstructions": "Nachdem ein Kunde arrieves und zeigt einen Autorisierungscode, überprüfen Sie, dass Code, Gültigkeit und Wert in der Verwaltung. Entkräftet den Gutschein sofort nach dem Gebrauch.",
                "conditions": {
                    "delivery": "Der Gutschein wird nach der Zahlung an Ihre E-Mail-Adresse zugeschickt.",
                    "extent": "Der Gutschein kann nur für Essen und Getränke in unserem Restaurant verwendet werden.",
                    "validity": "{0}Der Gutschein ist nach der Zahlung {months} Monate gültig.|{1}Der Gutschein ist nach der Zahlung {months} Monat gültig.|[2,*] Der Gutschein ist nach der Zahlung {months} Monate gültig."
                },
                "generatedVoucher": "eine neue Zahlung für einen Gutschein im Wert vorgenommen wurde.",
                "infoInMail": "Zahlungsanweisungen können auch in Ihrem E-Mail-Posteingang gefunden werden.",
                "invalidVoucher": "Gutschein ist nicht mehr gültig.",
                "newOrder": "Neue Bestellung",
                "newOrderNumber": "ein neuer Auftrag mit der Nummer <strong>{number}</strong>.",
                "newVoucher": "ein Gutschein wurde für Sie soeben generiert.",
                "number": "Ihre Bestellnummer ist: <strong>{number}</strong>.",
                "orderConfirmation": "Wir bestätigen Ihre Bestellung Geschenkgutschein.",
                "paidVoucher": "Bezahlt",
                "paymentInfo": "Zahlungsanweisungen",
                "paymentRedirect": "Umleiten zu Payment-Gateway wird gerade verarbeitet.",
                "paymentsInfo": {
                    "bankTransfer": {
                        "amount": "Betrag",
                        "bankAccount": "Kontonummer",
                        "how": "Bitte überweisen Sie den Betrag auf unser Bankkonto.",
                        "restaurantInfo": "Überprüfen Sie Ihr Bankkonto in den nächsten Tagen. Wenn es eine Zahlung mit den rechten Referenznummer Zeichen es in der Verwaltung ist als bezahlt. Gutschein wird danach automatisch senden an einen Kunden sein.",
                        "variableSymbol": "Referenznummer"
                    },
                    "inPersonHow": "Bitte zahlen Sie für die Bestellung direkt in unserem Restaurant mit der Referenznummer <strong>{number}</strong>.",
                    "inPersonRestaurantInfo": "Nachdem ein Kunde arrieves zu Ihrem Restaurant mit einer Referenznummer und eine Zahlung für den Gutschein, markieren Sie diesen Gutschein als in der Verwaltung bezahlt. Gutschein wird danach automatisch senden an einen Kunden sein.",
                    "inPersonWhere": "Sie können uns während der Öffnungszeiten auf dieser Adresse finden: <strong>{address}</strong>."
                },
                "pdfPerex": "Der Gutschein kann nur für Essen und Getränke in unserem Restaurant verwendet werden.",
                "send": "Der Gutschein wurde an Ihre E-Mail-Adresse geschickt.",
                "serviceInfo": "Sie brauchen den Gutschein nicht zu drucken, den Autorisierungscode zu kennen reicht Ihnen aus. Geben Sie jedoch bei der Zahlung der Bedienung im Voraus Bescheid.",
                "stripeFailed": "Online-Zahlung wurde nicht bearbeitet.",
                "thankYou": "Vielen Dank für Ihre Bestellung.",
                "thankYouNumber": "vielen Dank für Ihre Bestellung mit der Auftragsnummer {number}.",
                "toUse": "Autorisierungscode",
                "validVoucher": "Gutschein ist bezahlt und gültig.",
                "validityEndsAt": "Gutschein ist gültig bis",
                "voucher": "Geschenkgutschein",
                "vouchers": "Gutscheine",
                "waitingForPayment": "Wir werden auf Ihre Zahlung warten.",
                "whatToDo": "Was benötigt wird, um jetzt zu tun"
            }
        },
        "panel": {
            "controlPanel": ""
        },
        "reservation": {
            "back": "Zurück",
            "contact-info": "Kontaktinformation",
            "continue": "Fortsetzen",
            "date": "Datum",
            "details": "[2,*] <strong>{date}</strong> um <strong>{time}</strong> für <strong>{persons}</strong> Personen auf den Namen <strong>{name}</strong>",
            "find-us": "Wo finden Sie uns?",
            "goodbye": "Wir wünschen Ihnen einen schönen Tag",
            "hello": "Guten Tag",
            "manage-reservation": "Verwalten Reservierung",
            "name": "Name",
            "name-hint": "Für diese Person wird die Reservierung gemacht",
            "notAvailable": "Es ist nicht möglich, eine Online-Reservierung zu diesem Zeitpunkt zu machen.",
            "note": "Hinweis",
            "persons": "Personen",
            "phone": "Telefon",
            "phone-reservation": "Reservierungen sind auch telefonisch unter <a href=\"tel:{phone}\">{phone}</a> möglich.",
            "pre-confirmation-text": "Ihre Reservierung wartet nun auf eine Bestätigung. Sobald es Änderungen gibt, werden wir Sie per E-Mail informieren. Falls das Restaurant derzeit beschäftigt ist, kann es eine Weile dauern. Vielen Dank für Ihr Verständnis.",
            "pre-reservation-text": "Wir schicken Ihnen einen Link, über den Sie jederzeit den Status Ihrer Reservierung überprüfen können. Falls Sie einen anderen Tag buchen möchten oder einen Tisch für mehrere Personen buchen wollen, kontaktieren Sie uns bitte telefonisch.",
            "reservation": "Reservierung",
            "reserve": "Reservieren",
            "show-reservation": "Reservierung anzeigen",
            "statuses": {
                "canceled": {
                    "notice": "Storniert",
                    "sentence": "Ihre Reservierung wurde storniert",
                    "short": "Storniert",
                    "subject": "Abgebrochene Reservierung"
                },
                "confirmed": {
                    "notice": "Bestätigt vom Restaurant",
                    "sentence": "Ihre Reservierung wurde bestätigt",
                    "short": "Bestätigt",
                    "subject": "Bestätigte Reservierung"
                },
                "new": {
                    "notice": "Erfolgreich gesendet",
                    "sentence": "Wir haben Ihre Reservierung bekommen",
                    "sentence-admin": "neue Reservierung wird gerade erstellt",
                    "short": "Neu",
                    "subject": "Neue Reservierung"
                }
            },
            "time": "Zeit",
            "vue-details": ". | . | Reservierung am <strong>{date}</strong> um  <strong>{time}</strong> für <strong>{persons}</strong> Personen"
        },
        "admin": {
            "action": {
                "add": "Hinzufügen",
                "choose": "Wählen",
                "delete": "Smazat",
                "edit": "Bearbeiten",
                "show": "Show"
            },
            "bookmarks": {
                "placement": {
                    "footer": "Fusszeile",
                    "header": "Header"
                },
                "type": {
                    "link": "Verknüpfung",
                    "page": "Seite"
                }
            },
            "buttons": {
                "fill": "Füllen"
            },
            "categories": {
                "columns": {
                    "auto": "Automatisch",
                    "one": "Einer",
                    "two": "Zwei"
                }
            },
            "color": {
                "black": "Černá",
                "danger": "Achtung",
                "dark": "Dunkel",
                "info": "Informativ",
                "light": "Licht",
                "link": "Verknüpfung",
                "primary": "primär",
                "success": "Erfolg",
                "warning": "Warnung",
                "white": "Bílá"
            },
            "crud": {
                "exportPdf": "Export PDF",
                "lunchMenu": "Mittagsmenü"
            },
            "default": "Standard",
            "display": {
                "accepted": "Akzeptiert",
                "auto": "Automatisch",
                "hidden": "Versteckt",
                "not_accepted": "Nicht akzeptiert"
            },
            "entity": {
                "adminReservation": "Reservierungen verwalten",
                "adminVouchers": "verwalten Gutscheine",
                "blockedDays": "blockierte Tage",
                "blog": "Blog",
                "bookmark": "Lesezeichen",
                "category": "Kategorien",
                "content": "Inhalt",
                "contentBox": "Inhalt Boxen",
                "currentWeek": "Diese Woche",
                "decoration": "Dekorationen",
                "gallery": "Galerien",
                "general": "Allgemeines",
                "help": "Hilfe",
                "homeButton": "Home Buttons",
                "icon": "Icons",
                "ingredient": "Ingredients",
                "ingredientGroup": "Ingredient Groups",
                "integrations": "Integrations",
                "language": "Sprachen",
                "lunchFeed": "XML-Feeds",
                "lunchWeek": "Diese Woche Nächste Woche",
                "lunchmenu": "Mittagsmenüs",
                "lunchmenuday": "Mittagessen Tage",
                "meal": "Mahlzeit",
                "news": "Nachrichten",
                "nextWeek": "Nächste Woche",
                "notification": "Benachrichtigungen",
                "offer": "Bietet an",
                "offerMeal": "Mahlzeit",
                "offerMenu": "Menüs",
                "onlineOrders": {
                    "deliveryTypes": "",
                    "index": "",
                    "orders": "",
                    "paymentTypes": ""
                },
                "openingHour": "Öffnungszeiten",
                "openingHourDate": "Besondere Tage",
                "openingHourDay": "Tage in der Woche",
                "page": "Seiten",
                "partnerProgram": "Partner-Programm",
                "payment": "Zahlungen",
                "paymentMethod": "Zahlungsarten",
                "paymentType": "Zahlung openingTypes",
                "reservation": "Reservierungen",
                "service": "Dienstleistungen",
                "setting": "die Einstellungen",
                "socialNetworks": "Soziale Netzwerke",
                "tag": "Stichworte",
                "voucherValues": "Gutschein Werte",
                "vouchers": "Geschenkgutschein",
                "webPaymentMethod": "Web Zahlungen"
            },
            "export": {
                "fontSize": "Schriftgröße",
                "nextWeek": "Nächste Woche",
                "range": "Reichweite",
                "spacing": "Abstand",
                "thisWeek": "Diese Woche",
                "week": "Woche",
                "weekend": "Wochenende",
                "workdays": "Werktags"
            },
            "field": {
                "active": "Aktiv",
                "activeLanguage": "aktive Sprache",
                "address": "",
                "allergens": "Allergenen",
                "buttonTitle": "Schaltflächentext",
                "buttonUrl": "Verknüpfung",
                "category": "Kategorie",
                "childCategory": "Kinder Kategorie",
                "code": "Code",
                "columns": "Spalten zählen",
                "content": "Inhalt",
                "contentBox": "Inhalt Boxen",
                "created_at": "Hergestellt in",
                "customer": "",
                "date": "Datum",
                "dateFrom": "Stammen aus",
                "dateTo": "Datum bis",
                "day": "Wochentag",
                "description": "Beschreibung",
                "display": "Anzeige",
                "dontShowName": "Name nicht anzeigen",
                "free_price": "",
                "highlighted": "Hervorgehoben",
                "icon": "Symbol",
                "icon_color": "Iconfarbe",
                "id": "",
                "image": "",
                "imageType": "Bildanzeigetyp",
                "images": "Bilder",
                "internal": "Internes Etikett",
                "key": "Schlüssel",
                "kitchen": "Küche",
                "language": "Sprache",
                "link": "Verknüpfung",
                "lunch": "Mittagessen",
                "mealIcons": "Icons",
                "mealNum": "Anzahl der Mahlzeiten",
                "mealTag": "Etikett",
                "menickaCzType": "Kategorietyp für menicka.cz XML-Feed",
                "menu": "Menükarte",
                "message": "Botschaft",
                "module": "Modul",
                "name": "Name",
                "note": "Hinweis",
                "notificationOnClick": "Nach dem Klick-Aktion",
                "notificationType": "Benachrichtigungstyp",
                "notificationValidity": "Mitteilung Gültigkeit",
                "offer": {
                    "text_above": "Textinhalt über Angebot",
                    "text_below": "Text unterhalb Angebot"
                },
                "offerAvailability": "Angebot Verfügbarkeit",
                "offerMeals": {
                    "enabledOrders": "",
                    "enabledWeb": "",
                    "soldOut": ""
                },
                "offered": "Angeboten",
                "onlineOrders": {
                    "deliveryType": "",
                    "firstname": "",
                    "lastname": "",
                    "order": "",
                    "orderItems": "",
                    "paymentType": "",
                    "totalPrice": ""
                },
                "open": "geöffnet",
                "packagingPrice": "",
                "parentCategory": "Eltern-Kategorie",
                "payed_at": "Bezahlt",
                "person_name": "Name",
                "persons": "Personen",
                "phone": "Telefon",
                "placement": "Platzierung",
                "portion": "Portion",
                "price": "Preis",
                "primary": "primär",
                "primaryLanguage": "Muttersprache",
                "reason": "Grund",
                "response": "Antwort",
                "restaurant": "Restaurant",
                "showInMenu": "Zeigen Sie im Menü",
                "socialNetwork": "Soziales Netzwerk",
                "state": "Status",
                "status": "Status",
                "style": "Stil",
                "subtitle": "Untertitel",
                "time": "Zeit",
                "timeFrom": "Von",
                "timeTo": "Zu",
                "title": "Titel",
                "title-image": "Ilustration unter dem Titel",
                "type": "Art",
                "url": "URL-Adresse",
                "validFrom": "Gültig ab",
                "validTo": "Gültig bis",
                "validity": "Gültigkeit",
                "value": "Wert",
                "variable_symbol": "Ref. Nummer"
            },
            "filter": {
                "category": "Kategorie",
                "date": "Datum",
                "gallery": "Galerie",
                "general": "Allgemeines",
                "module": "Modul"
            },
            "help": {
                "availableSettings": "Verfügbare Einstellungen",
                "basicInfo": "Grundinformation",
                "recommended": "empfohlen",
                "set": "die Einstellungen"
            },
            "hint": {
                "activeLanguage": "Sprache Mutation der Website <br /> <strong> Achtung -.. Fehleinstellungen können bewirken, dass die Web-Anwendung nicht mehr funktioniert </ strong>",
                "dateTo": "Wenn das Datum nicht gesetzt ist, ist die Öffnungszeit endlos. Sie können es löschen, indem Sie das Papierkorb-Symbol im Kalender verwenden.",
                "internal": "Nur in adminisration Tafel verwendet.",
                "menickaCzType": "Ignorieren, wenn Sie nicht menicka.cz XML-Feed verwenden Sie.",
                "notificationContent": "Für Inhalte angezeigt werden Sie `Nach klicken action` auf` Modal` Wert muss",
                "notificationLink": "Für Link zu arbeiten, die Sie `Nach klicken action` auf` Link` Wert muss",
                "notificationOnClick": "\n<ul>\n    <li> <b> Nichts </b> -. Es passiert nichts, nach Klick </li>\n    <li> <b> Link </b> -. Besucher umgeleitet wird </li>\n    <li> <b> Modal </b> -. Modal Fenster (Pop-up) mit zusätzlichem Inhalt geöffnet wird, </li>\n</ul>",
                "notificationType": "\n<ul>\n    <li> <b> Info </b> - Geeignet für Standard-Betriebsinformation, Anmeldung ist blau </li>\n    <li> <b> Erfolg </b> - Geeignet für neue Angebote oder Veranstaltungen, Benachrichtigung grün </li>\n    <li> <b> Warnung </b> - Geeignet für den Betrieb blockiert Ereignisse, Benachrichtigung ist gelb </li>\n</ul>",
                "offered": "Wenn der Dienst vom Restaurant angeboten.",
                "primaryLanguage": "Sprache Mutation der Admin-Seite der Website und Standardsprache Mutation der Website <br /> <strong> Achtung -.. Fehleinstellungen können bewirken, dass die Web-Anwendung nicht mehr funktioniert </ strong>",
                "reason": "Hinweis zum Öffnen Stunde",
                "showInMenu": "Durch Ausschalten werden Sie ganze Artikel auf der Website verstecken.",
                "type": "Typ Wert ändert Iconfarbe",
                "validTo": "Wenn das Datum nicht gesetzt ist, hat das Menü unendliche Gültigkeit. Sie können es löschen, indem Sie das Papierkorb-Symbol im Kalender verwenden.",
                "withoutName": "Durch die Überprüfung ist es anstelle des Namens der Kategorie numerischer Reihenfolge. Menü 1 / Menu 2 und so weiter."
            },
            "imageType": {
                "contain": "Enthält (Bild wird nicht beschnitten wird erhalten, nicht ganzes Gebiet gefüllt)",
                "cover": "Deckel (gesamte Fläche gefüllt wird, wird Bild beschnitten werden)"
            },
            "integrations": {
                "instagram": {
                    "description": "",
                    "name": ""
                }
            },
            "lunchmenuday": {
                "column": {
                    "serving": "Wir servieren Menü"
                },
                "field": {
                    "serving": "Wir servieren Menü"
                },
                "hint": {
                    "reason": "Der Grund, warum kein Mittagsmenü serviert."
                }
            },
            "menickaCzType": {
                "jidlo": "Mahlzeit",
                "polevka": "Suppe"
            },
            "notificationOnClick": {
                "close": "Nichts",
                "link": "Verknüpfung",
                "modal": "Modal",
                "popup": ""
            },
            "notificationType": {
                "is-info": "Die Info",
                "is-success": "Erfolg",
                "is-warning": "Warnung"
            },
            "nums": {
                "items": "{0} Keine Produkte|{1} {num} Artikel|[2,*] {num} Artikel",
                "notifications": "{0} Keine aktiven Benachrichtigungen |{1} {num} aktive Benachrichtigung | [2,*] {num} aktive Benachrichtigungen",
                "reservations": "{0} Keine unresponded resertvations | {1} {num} neue Reservierung | [2,*] {num} neue Reservierungen"
            },
            "offer": {
                "additional": "Weitere Informationen zu Ihrem Angebot.",
                "hint": "Legen Sie alle Ihre Menüpunkte hier."
            },
            "offerMeals": {
                "variant": "Variante",
                "variants": "Weitere Varianten"
            },
            "operations": {
                "qrCode": "QR-Code"
            },
            "options": {
                "active": [
                    "Inaktiv",
                    "Aktiv"
                ],
                "primary": [
                    "Nein",
                    "Ja"
                ]
            },
            "pages": {
                "blog": "Blog",
                "contact": "Impressum",
                "homepage": "Startseite",
                "lunch_menu": "Mittagsmenü",
                "offer": "Angebot",
                "reservation": "Reservierungen",
                "vouchers": "Geschenkgutschein"
            },
            "reservation": {
                "actions": {
                    "cancel": "Reservierung stornieren",
                    "confirm": "Reservierung bestätigen"
                },
                "notifications": {
                    "canceled": "Reservierung wurde storniert",
                    "confirmed": "Reservierung wurde bestätigt,"
                },
                "sendEmail": "Senden notifiation E-Mail an den Kunden"
            },
            "sample": {
                "customiseDesign": "Passen Sie Ihre Installation",
                "firstTime": "Besuchen Sie uns zum ersten Mal?",
                "showInfo": "Show"
            },
            "show-website": "Webseite anzeigen",
            "state": {
                "hidden": "Versteckt"
            },
            "validSettings": "Gültige Einstellungen",
            "vouchers": {
                "appliedSuccess": "Gutschein wurde für ungültig erklärt.",
                "apply": "Invalidate",
                "pay": "Zahlen",
                "payedSuccess": "Gutschein bezahlt wurde."
            },
            "webPaymentMethod": {
                "bank_transfer": "Bank trasnfer",
                "in_person": "Persönlich auf Prämisse",
                "stripe": "Stripe - Online-Zahlung"
            },
            "webPaymentMethodHint": {
                "bank_transfer": "Bankkontonummer muss im Web-Zahlungseinstellungen festgelegt werden.",
                "in_person": "Die Adresse muss in Kontakt Einstellungen festgelegt werden.",
                "stripe": "Live-Stripe-API-Schlüssel müssen in Web-Zahlungseinstellungen festgelegt werden."
            }
        },
        "orders": {
            "actions": {
                "addMoreItems": "",
                "addNote": "",
                "back": "",
                "backMoreItems": "",
                "manage": "",
                "order": "",
                "orderOnline": "",
                "removeNote": "",
                "show": ""
            },
            "address": "",
            "cart": "",
            "cartContent": "",
            "customer": "",
            "delivery": "Lieferung",
            "deliveryAddress": "",
            "deliveryType": "",
            "deliveryTypes": {
                "delivery": "",
                "takeaway": ""
            },
            "email": "",
            "firstname": "",
            "lastname": "",
            "mail": {
                "stateChange": "",
                "states": {
                    "CANCELLED": {
                        "state": "",
                        "title": ""
                    },
                    "CONFIRMED": {
                        "state": "",
                        "title": ""
                    },
                    "NEW": {
                        "state": "",
                        "title": ""
                    },
                    "ON_DELIVERY": {
                        "state": "",
                        "title": ""
                    },
                    "PENDING_PAYMENT": {
                        "state": "",
                        "title": ""
                    },
                    "READY_TO_PICKUP": {
                        "state": "",
                        "title": ""
                    },
                    "restaurant_NEW": {
                        "state": "",
                        "title": ""
                    }
                }
            },
            "method": "",
            "note": "",
            "order": "",
            "orderNum": "",
            "orderNumber": "",
            "orderOnline": "Online bestellen",
            "ordering": {
                "active": "",
                "paused": ""
            },
            "orders": "",
            "packaging": "",
            "paidAt": "",
            "payment": "",
            "paymentAndDelivery": "",
            "paymentType": "",
            "paymentTypes": {
                "card_on_delivery": "",
                "cash": "",
                "meal_vouchers": "",
                "online_stripe": ""
            },
            "phone": "",
            "state": "",
            "states": {
                "CANCELLED": "",
                "CLOSED": "",
                "CONFIRMED": "",
                "CREATING": "",
                "NEW": "",
                "ON_DELIVERY": "",
                "PAYMENT_PENDING": "",
                "READY_TO_DELIVERY": "",
                "READY_TO_PICKUP": ""
            },
            "stripe": {
                "canceled": "",
                "paymentRedirect": ""
            },
            "total": "",
            "zeroItems": ""
        }
    },
    "en": {
        "Ordering system": "Objednávkový systém",
        "Ordering systems": "Objednávkové systémy",
        "Title": "Název",
        "Provider": "Poskytovatel",
        "Own ordering system": "Vlastní objednávkový systém",
        "Create": "Vytvořit",
        "Save": "Uložit",
        "datetime": {
            "days": {
                "1": "Monday",
                "2": "Tuesday",
                "3": "Wednesday",
                "4": "Thursday",
                "5": "Friday",
                "6": "Saturday",
                "7": "Sunday",
                "8": "Bank holiday"
            },
            "daysShort": {
                "1": "Mo",
                "2": "Tu",
                "3": "We",
                "4": "Th",
                "5": "Fr",
                "6": "Sa",
                "7": "Su",
                "8": "Ho"
            },
            "from": "from",
            "nextWeek": "Next week",
            "thisWeek": "This week",
            "today": "Today",
            "tomorrow": "Tomorrow",
            "until": "to"
        },
        "settings": {
            "contact": {
                "address": {
                    "description": "Address of the restaurant",
                    "hint": "Address will not only be used to the customers but also to find the location on google maps."
                },
                "email": {
                    "description": "E-mail"
                },
                "ic": {
                    "description": "Company ID"
                },
                "info": {
                    "description": "Additional info on contact page"
                },
                "module": "Contacts",
                "name": {
                    "description": "Restaurant name (This will be shown on website)"
                },
                "operator": {
                    "description": "Comapny that operates the restaurant"
                },
                "phone": {
                    "description": "Phone number"
                },
                "show_email": {
                    "description": ""
                },
                "show_kitchen": {
                    "description": "Show opening hours of kitchen"
                }
            },
            "cta": {
                "custom_style": {
                    "description": "",
                    "hint": "",
                    "options": {
                        "black": "",
                        "blue": "",
                        "danger": "",
                        "success": "",
                        "warning": "",
                        "white": ""
                    }
                },
                "custom_text": {
                    "description": "",
                    "hint": ""
                },
                "custom_url": {
                    "description": "",
                    "hint": ""
                },
                "module": "",
                "type": {
                    "description": "",
                    "options": {
                        "contact": "",
                        "custom": "",
                        "none": "",
                        "order_online": "",
                        "phone": "",
                        "table_reservation": ""
                    }
                }
            },
            "external": {
                "facebook_pixel": {
                    "description": "Facebook Pixel",
                    "hint": "Insert just the tracking ID, eg.: <strong>926140414437894</strong>"
                },
                "google_analytics": {
                    "description": "Google Analytics",
                    "hint": "Insert just the tracking ID, eg.: <strong>UA-123456789-3</strong>"
                },
                "google_analytics_4": {
                    "description": "",
                    "hint": ""
                },
                "google_tag_manager": {
                    "description": "",
                    "hint": ""
                },
                "module": "Tracking codes"
            },
            "font": {
                "display": {
                    "description": "",
                    "options": {
                        "alice": "",
                        "blink-mac": "",
                        "caveat": "",
                        "comfortaa": "",
                        "cormorant-infant": "",
                        "cormorant-sc": "",
                        "eb-garamond": "",
                        "lobster": "",
                        "lora": "",
                        "merriweather": "",
                        "montserrat": "",
                        "overpass": "",
                        "pacificio": "",
                        "palanquin-dark": "",
                        "playfair-display": "",
                        "prata": "",
                        "pt-sans": "",
                        "roboto": "",
                        "ubuntu": "",
                        "yeseva-one": ""
                    }
                },
                "module": "",
                "text": {
                    "description": "",
                    "options": {
                        "blink-mac": "",
                        "lora": "",
                        "merriweather": "",
                        "montserrat": "",
                        "open-sans": "",
                        "raleway": "",
                        "roboto": "",
                        "ubuntu": ""
                    }
                }
            },
            "gallery": {
                "label": {
                    "description": "Gallery label",
                    "hint": "Fill out only if you want to change the default \"Gallery\" label."
                },
                "module": "Gallery",
                "thumbnail": {
                    "description": "Type of thumbnails inside gallery",
                    "hint": "<strong>cover</strong> (default) - suitable if most of the photos are in landscape format - the pictures will be cropped out, however every picture will looks similar<br /><strong>fit</strong> - suitable if the photos do not have similar format or most of them are in portrait format",
                    "options": {
                        "cover": "",
                        "fit": ""
                    }
                }
            },
            "general": {
                "background_image": {
                    "description": "General - Background picture",
                    "hint": "The image that is used in the background (visible unless of course, set a fixed view or if it is released as a picture in the header)."
                },
                "box": {
                    "description": "",
                    "options": {
                        "heavy": "",
                        "lite": "",
                        "relief": "",
                        "shadow": "",
                        "smooth": ""
                    }
                },
                "floated_logo": {
                    "description": "Floating logo",
                    "hint": "Warning, floating logo is an advanced settings option usable only with appropriate data."
                },
                "footer_style": {
                    "description": "Footer color",
                    "hint": "Changes footer color of website.",
                    "options": {
                        "black": "Black",
                        "dark": "Dark",
                        "light": "Light",
                        "white": "White"
                    }
                },
                "logo": {
                    "description": "Restaurant logo"
                },
                "logo_dark": {
                    "description": "General - Dark restaurant logo",
                    "hint": "To be used on light backround."
                },
                "logo_light": {
                    "description": "General - Light restaurant logo",
                    "hint": "To be used on dark background."
                },
                "logo_pdf": {
                    "description": "Restaurant logo for PDF exports"
                },
                "module": "Design",
                "nav_bar_shadow": {
                    "description": "Shadowing of the main navigation bar",
                    "options": {
                        "shadow-heavy": "Heavy",
                        "shadow-light": "Light",
                        "shadow-none": "Without shadowing"
                    }
                },
                "nav_bar_size": {
                    "description": "Size of the main navigation bar",
                    "hint": "Ovlivňuje jak velkou část obrazovky bude hlavní navigační lišta zabírat.",
                    "options": {
                        "is-large": "Big",
                        "is-medium": "Medium",
                        "is-small": "Small"
                    }
                },
                "navbar_logo_size": {
                    "description": "Navbar - logo size",
                    "hint": "Advanced settings",
                    "options": {
                        "default": "",
                        "float": "",
                        "full": ""
                    }
                },
                "navigation_content_position": {
                    "description": "",
                    "options": {
                        "center": "",
                        "left": "",
                        "right": "",
                        "split": ""
                    }
                },
                "navigation_highlight": {
                    "description": "Navbar link highlighting method",
                    "hint": "Ovlivňuje jakým způsobem se zvýrazní právě aktivní položka v navigační liště a položka na kterou návštěvník najede myší.",
                    "options": {
                        "has-highlight-background": "Background",
                        "has-highlight-color": "Hue",
                        "has-highlight-underline": "Underline"
                    }
                },
                "navigation_transparent": {
                    "description": "Navbar - Opacity",
                    "hint": "It affects whether the navigation bar in the initial position transparent. Transparent navigation bar appears only when it is on the page header background image. The setting is also available and choice through which it is possible to add a background image globally to all sites.",
                    "options": [
                        "No",
                        "Yes"
                    ]
                },
                "navigation_width": {
                    "description": "",
                    "options": {
                        "fixed": "",
                        "fluid": ""
                    }
                },
                "notifications_above_navigation": {
                    "description": "General - Notification position",
                    "hint": "It affects where that quick notification (notification) zobrazají above or below the navigation bar.",
                    "options": [
                        "Over navbar",
                        "Under navbar"
                    ]
                },
                "padding": {
                    "description": "",
                    "options": {
                        "large": "",
                        "medium": "",
                        "small": ""
                    }
                },
                "primary_color": {
                    "description": "Primary color",
                    "hint": "Ovlivňuje barvu hlavní navigační lišty a tlačítka pro rychlý přechod do nabídky jídel.",
                    "options": {
                        "black": "Black",
                        "blue": "Blue",
                        "brown": "Brown",
                        "dark": "Dark",
                        "green": "Green",
                        "light": "Light",
                        "red": "Red",
                        "white": "White",
                        "yellow": "Yellow"
                    }
                },
                "secondary_color": {
                    "description": "Secondary color",
                    "hint": "Ovlivňuje barvu většiny nadpisů, šipky pro rychlé vyrolování webu nahoru a podkladovou barvu pro zvýrazněné kategorie jídelního lístku. Rozdíly v barvě nadpisů mohou být u některých témat vzhledem k tloušťce písem velmi jemné.",
                    "options": {
                        "black": "Black",
                        "blue": "Blue",
                        "brown": "Brown",
                        "dark": "Dark",
                        "green": "Green",
                        "red": "Red"
                    }
                },
                "social_accounts_style": {
                    "description": "Social accounts icons style",
                    "hint": "Changes the appearance of icons of social accounts.",
                    "options": {
                        "round-bw": "Black&white circle",
                        "round-color": "Colored circle",
                        "square-bw": "Black&white square",
                        "square-color": "Colored square"
                    }
                },
                "theme": {
                    "description": "Wistro theme",
                    "hint": "Jemně ovlivňuje většinu prvků celého webu, tj. například písma, odstíny, přechody, tlačítka a významněji potom hlavní navigační lištu. Volba Wistro tématu je čistě pocitová záležitost.",
                    "options": {
                        "cerulean": "Cerulean",
                        "default": "Bulma",
                        "lumen": "Lumen",
                        "putty": "Putty",
                        "sandstone": "Sandstone"
                    }
                },
                "title_size": {
                    "description": "Size of titles",
                    "hint": "Ovlivňuje velikost plochy pro hlavní nadpisy na jednotlivých stránkách.",
                    "options": {
                        "is-large": "Large",
                        "is-larger": "Larger",
                        "is-largest": "Largest",
                        "is-medium": "Medium",
                        "is-small": "Small"
                    }
                },
                "use_background_inside_header": {
                    "description": "General - Use background image in header",
                    "hint": "If it is not on the selected image to automatically head to complement her image intended for background.",
                    "options": [
                        "No",
                        "Yes"
                    ]
                },
                "width": {
                    "description": "Layout width",
                    "hint": "<p>It affects how it behaves space left and right around the content itself. When the flexible display, the entire space is filled with background color of the section (ie. From edge to edge). With a fixed display additional space fills opening image. </p> <p> <strong> Warning </strong> - the difference is noticeable only at large, for example. FullHD monitors (resolution 1920px and higher). </p>",
                    "options": {
                        "fixed": "Fixed",
                        "fluid": "Fluid",
                        "semi-fixed": "Fixed with fluid navbar",
                        "semi-fluid": "Fluid with fixed navbar"
                    }
                }
            },
            "homepage": {
                "bouncing_button": {
                    "description": "Bouncing button",
                    "hint": "Ovlivňuje zda se na homepage zobrazuje tzv. neposedné tlačítko, které upozorňuje návštěvníka, že úvodní stránka pokračuje směrem dolů. Tlačítko doporučujeme zapnout pokud máte na úvodní stránce dodatečný obsah, ideálně včetně fotografií.",
                    "options": [
                        "No",
                        "Yes"
                    ]
                },
                "content_position": {
                    "description": "Homepage content position",
                    "hint": "Affects the position of content on the home page. To ensure good legibility is applied to the main picture small dark transition. Location in the middle when the transition is noticeable, so it is recommended only if your initial image rather darker shades.",
                    "options": {
                        "body": "Middle",
                        "head": "Top"
                    }
                },
                "header_height": {
                    "description": "",
                    "options": {
                        "100": "",
                        "33": "",
                        "66": "",
                        "80": ""
                    }
                },
                "image": {
                    "description": "Picture on the home page"
                },
                "logo": {
                    "description": "Logo on homepage",
                    "hint": "Warning, this is an advanced settings option usable only with appropriate data."
                },
                "module": "Homepage",
                "quick_links": {
                    "description": "",
                    "options": {
                        "is-disabled": "",
                        "is-gradient": "",
                        "is-transparent": "",
                        "is-white": ""
                    }
                },
                "show_blog": {
                    "description": "Show blog articles on homepage"
                },
                "show_offer_boxes": {
                    "description": "Homepage - offer tiles",
                    "hint": "Adds large offer tiles to homepage.",
                    "options": [
                        "No",
                        "Yes"
                    ]
                },
                "show_offer_link": {
                    "description": "Show link to first offer card",
                    "options": [
                        "No",
                        "Yes"
                    ]
                },
                "show_opening_hours": {
                    "description": "Show opening hours on homepage",
                    "hint": "Shows opening hours on homepage.",
                    "options": [
                        "No",
                        "Yes"
                    ]
                },
                "show_slideshow": {
                    "description": "",
                    "options": [
                        "",
                        ""
                    ]
                },
                "show_title_lower": {
                    "description": "Show restaurant name below main picture",
                    "hint": "Vhodné pro podniky, které mají na úvodní stránce umístěno vlastní logo s jasně čitelným názvem podniku"
                },
                "tagline": {
                    "description": "Main annotation"
                }
            },
            "lunch_menu": {
                "availability_enabled": {
                    "description": "Show availability"
                },
                "compact": {
                    "description": "Compact view",
                    "hint": "Name of category on the same row as meal name"
                },
                "enabled": {
                    "description": "Enable lunch menu"
                },
                "label": {
                    "description": "Lunch menu label",
                    "hint": "Enter only if you want to customised the text used on Lunch menu, be aware that URL address will also change."
                },
                "module": "Lunch menu",
                "not_set_label": {
                    "description": ""
                },
                "packaging_enabled": {
                    "description": "Show packaging price"
                },
                "pdf_text": {
                    "description": "Text that is added on lunch menu print PDFs."
                },
                "show_allergens": {
                    "description": "Show allergens"
                },
                "show_empty_day": {
                    "description": "Zobrazovat i dny, pro které není zadaná nabídka",
                    "hint": "Zobrazení je vhodné vypnout pro podniky, které zadávají nabídku pouze jeden den dopředu"
                },
                "show_portion": {
                    "description": "Show size of portion"
                },
                "show_time": {
                    "description": "Show lunch time serving time"
                },
                "show_week": {
                    "description": "Fill week menu"
                },
                "week_after_daily": {
                    "description": "Add week menu after daily menu"
                }
            },
            "orders": {
                "disable_ordering": {
                    "description": "Block ordering until revoked"
                },
                "disable_ordering_until": {
                    "description": "Block ordering until the selected time"
                },
                "email": {
                    "description": "E-mail address to notify"
                },
                "enabled": {
                    "description": "Enable module"
                },
                "lunch_enabled": {
                    "description": "Allow daily menu sales"
                },
                "module": "Online sales",
                "require_connected_panel": {
                    "description": "Block ordering without control panel attached"
                },
                "sent_restaurant_notifications_emails": {
                    "description": "Send email notifications to the restaurant about a new orders"
                },
                "time_restrictions_lunch": {
                    "description": "Allow ordering the lunch menu only at a defined time",
                    "hint": ""
                },
                "time_restrictions_offer": {
                    "description": "Allow ordering from the permanent menu only at a defined time",
                    "hint": ""
                }
            },
            "reservation": {
                "days_from": {
                    "description": "Allow reservations after how many days"
                },
                "days_to": {
                    "description": "Allow reservations for how many days"
                },
                "email": {
                    "description": "E-mail for notifications"
                },
                "enabled": {
                    "description": "Allow reservations"
                },
                "max_persons": {
                    "description": "Maximum number of persons for reservations"
                },
                "module": "Reservation",
                "phone": {
                    "description": "Phone number"
                },
                "show_form": {
                    "description": ""
                },
                "time_from": {
                    "description": "From what time are reservations allowed"
                },
                "time_to": {
                    "description": "Until what time are reservations allowed"
                }
            },
            "structured_data": {
                "address_country": {
                    "description": "Address (State)",
                    "hint": ""
                },
                "address_locality": {
                    "description": "Address (City)"
                },
                "address_postal_code": {
                    "description": "Adresa (Zipcode)",
                    "hint": ""
                },
                "module": "Structured data",
                "price_range": {
                    "description": "Price range",
                    "hint": ""
                },
                "serves_cuisine": {
                    "description": "Serces cuisine",
                    "hint": ""
                },
                "street_address": {
                    "description": "Address (Street)"
                }
            },
            "vouchers": {
                "email": {
                    "description": "E-mail for notifications"
                },
                "enabled": {
                    "description": "Enable gift vouchers"
                },
                "module": "Gift vouchers",
                "validity": {
                    "description": "Gift vouchers validity length in months"
                }
            },
            "web_payments": {
                "bank_account": {
                    "description": "Bank account number",
                    "hint": "Enter full bank account number, e.g.: <strong>670100-2204743278/6210</strong>"
                },
                "module": "Web payments",
                "stripe_pk": {
                    "description": "Stripe - Publishable key",
                    "hint": "Ensure that prefix of your key is same: <strong>pk_live_</strong>xxxxxxxxxxxxxxxxxxxxx"
                },
                "stripe_sk": {
                    "description": "Stripe - Secret key",
                    "hint": "Ensure that prefix of your key is same: <strong>sk_live_</strong>xxxxxxxxxxxxxxxxxxxxx"
                }
            }
        },
        "vue": {
            "add": "Add",
            "addDate": "Add specific date",
            "back": "Back",
            "break": "Přerušení otevírací doby",
            "close": "Close",
            "closed": "Closed",
            "continue": "Continue",
            "deleted": "Deleted",
            "kitchen": "Kitchen hours",
            "lunchMenu": "Lunch menu",
            "noBreak": "Bez přerušení otevírací doby",
            "notServing": "Not serving",
            "notShown": "Do not show",
            "restaurant": "Restaurant",
            "save": "Save",
            "saved": "Saved successfully",
            "serving": "Serving",
            "vouchers": {
                "deliveryEmail": "E-mail for delivery",
                "email": "E-mail",
                "emailHelp": "We will send the gift voucher to this e-mail.",
                "inscription": "Inscription",
                "inscriptionHelp": "Inscription is optional",
                "isOk": "Are all entries correct?",
                "order": "Order",
                "pay": "Pay",
                "paymentMethod": "Payment method",
                "paymentMethods": {
                    "bank_transfer": "Bank transfer",
                    "in_person": "In person on premise",
                    "stripe": "Online payment"
                },
                "recapitulation": "Order summary",
                "voucherValue": "Voucher value"
            },
            "sendReservation": "Send reservation",
            "reservationForm": "Reservation form",
            "message": "Message",
            "Yes": "Yes",
            "No": "No",
            "newsletter": "I agree to receive marketing communications"
        },
        "wistro": {
            "about_us": "About us",
            "cookies": {
                "actions": {
                    "accept": "Accept",
                    "accept_all": "Accept all",
                    "accept_required": "Accept mandatory",
                    "accept_selected": "Accept selected",
                    "adjust": "Adjust",
                    "hide_details": "Hide details",
                    "show_details": "Show details"
                },
                "additionalInfo": "<p>The mentioned companies also handle cookies in accordance with their contractual conditions:</p>",
                "content": "<h3>What are cookies?</h3>\n<p>Cookies are short text files that a website sends to your browser. They allow the website to record information about your visit, such as the language you choose and so on. The next visit to the site may be easier and more pleasant for you. Cookies are important because without them browsing the Internet would be much more difficult. Cookies allow you to make better use of our website and adapt its content to your needs. Cookies are used by almost every website in the world. Cookies are useful because they increase the user-friendliness of repeatedly visited websites.</p>\n<h3>Types of cookies</h3>\n<p>Relational (ie temporary) cookies allow us to link your individual activities while browsing this website. These files are activated when your browser window is opened and deactivated when you close your browser window. Relational cookies are temporary and all these files are deleted when you close the browser.</p>\n<p>Persistent cookies help us identify your computer if you revisit our website. Another advantage of persistent cookies is that they allow us to tailor our website to your needs.</p>\n<h3>Use of cookies</h3>\n<p>In accordance with the provisions of § 89 par. 3 of Act no. No. 127/2005 Coll., on electronic communications, as amended, we hereby inform you that our website uses cookies for its activities, ie we process your cookies, including permanent ones.</p>\n<h3>Purpose of using cookies</h3>\n<p>We use cookies to analyze our traffic. We share information about how you use our site with our social media, advertising and analytics partners. We do use the following services:</p>",
                "cookie_settings": "Cookies settings",
                "cookies": {
                    "XSRF_TOKEN": "Slouží k prevenci před CSRF/XSRF útoky.",
                    "_fbp": "Slouží k cílení zobrazovaní relevantních reklam na digitální platformě Facebook.",
                    "_ga": "Slouží k rozlišení uživatelů v rámci Google Analytics.",
                    "_gat": "Slouží k omezení počtu požadavků do Google Analytics.",
                    "_gid": "Slouží k rozlišení uživatelů v rámci Google Analytics.",
                    "cookies_consent": "Slouží k uložení vašeho nastavení cookies.",
                    "laravel_session": "Slouží k identifikaci stavu webové stránky."
                },
                "cookies_description": "Description",
                "cookies_identifier": "Identifier",
                "description": "Information about files and the use of cookies",
                "info": "We use cookies to ensure the security and proper functioning of the site.",
                "more": "Learn more about handling <a href=\"{url}\" target=\"_blank\"> cookies <span class=\"icon\"> <i class=\"fa fa-external-link-alt\"> </i> </ span> </a>",
                "not_used": "Not used",
                "required": "Mandatory",
                "settings": "Settings",
                "title": "Cookies files",
                "types": {
                    "analytics": {
                        "description": "These cookies are used to analyze the use of the site.",
                        "name": "Analytical cookies"
                    },
                    "marketing": {
                        "description": "Use these files to target relevant ads to other platforms.",
                        "name": "Marketing cookies"
                    },
                    "required": {
                        "description": "These cookies are technically necessary for the proper functioning of the site.",
                        "name": "Mandatory cookies"
                    }
                }
            },
            "email": {
                "hello": "Hello"
            },
            "installation": "Installation",
            "installationInfo": "Information about this installation",
            "operation": "Operation",
            "vouchers": {
                "applyInstructions": "After a customer arrieves and shows an authorization code, check that code, validity and value in the administration. Invalidate the voucher immediately after use.",
                "conditions": {
                    "delivery": "The voucher will be delivered to your email address after payment.",
                    "extent": "Voucher can be used to pay for meal and drinks in our restaurant.",
                    "validity": "{0}The voucher is valid for {months} months after payment.|{1}The voucher is valid for {months} month after payment.|[2,*]The voucher is valid for {months} months after payment."
                },
                "generatedVoucher": "a new payment for a voucher has been made.",
                "infoInMail": "Payment instructions can be found also in your e-mail inbox.",
                "invalidVoucher": "Voucher is no longer valid.",
                "newOrder": "New order",
                "newOrderNumber": "a new order with number <strong>{number}</strong>.",
                "newVoucher": "we just generated a gift voucher for you. ",
                "voucher_reminder": "we just wanted to remind you that validity of your voucher ends soon.",
                "number": "We assigned the number: <strong>{number}</strong>.",
                "orderConfirmation": "we confirm your order for gift voucher.",
                "paidVoucher": "Paid",
                "paymentInfo": "Payment instructions",
                "paymentRedirect": "Redirect to payment gateway is beeing processed.",
                "paymentsInfo": {
                    "bankTransfer": {
                        "amount": "Amount",
                        "bankAccount": "Bank account number",
                        "how": "Please pay for the order by wiring funds to our bank account.",
                        "restaurantInfo": "Check your bank account in the next days. If there is a payment with the right reference number mark it in administration as paid. Voucher will be send to a customer automatically after that.",
                        "variableSymbol": "Reference number"
                    },
                    "inPersonHow": "Please pay for the order directly in our restaurant using reference number <strong>{number}</strong>.",
                    "inPersonRestaurantInfo": "After a customer arrieves to your restaurant with a reference number and makes a payment for the voucher, mark this voucher as paid in administration. Voucher will be send to a customer automatically after that.",
                    "inPersonWhere": "You can find us during opening hours on address: <strong>{address}</strong>."
                },
                "pdfPerex": "for consumpitons of meal and drinks in restaurant",
                "send": "We just sent your voucher to your e-mail address.",
                "serviceInfo": "You don't need to print the voucher, you just need to show the code. However please notifiy the service for voucher payment in advance.",
                "stripeFailed": "Online payment was not processed.",
                "thankYou": "Thank you for your order.",
                "thankYouNumber": "thank you for your order number {number}.",
                "toUse": "Authorization code",
                "validVoucher": "Voucher is paid and valid.",
                "validityEndsAt": "Voucher is valid until",
                "voucher": "Gift voucher",
                "vouchers": "Vouchers",
                "waitingForPayment": "We are waiting for the payment.",
                "whatToDo": "What is needed to do now"
            }
        },
        "panel": {
            "controlPanel": "Control panel"
        },
        "reservation": {
            "back": "Back",
            "contact-info": "Contact info",
            "continue": "Continue",
            "date": "Date",
            "details": "[2,*] <strong>{date}</strong> at <strong>{time}</strong> for <strong>{persons}</strong> persons on name <strong>{name}</strong>",
            "find-us": "Where to find us?",
            "goodbye": "Have a nice day",
            "hello": "Hello",
            "manage-reservation": "Manage reservation",
            "name": "Name",
            "name-hint": "This will be visible on the table",
            "notAvailable": "It is not possible to make an online reservation at this time.",
            "note": "Note",
            "persons": "Persons",
            "phone": "Phone",
            "phone-reservation": "Reservations are also accepted on phone number <a href=\"tel:{phone}\">{phone}</a>.",
            "pre-confirmation-text": "Your reservation is now waiting for confirmation. As soon as it state changes we will inform you to your email address. If the resturant is currently busy it can take as a while. Thanks for understanding.",
            "pre-reservation-text": "You will be able to check the status of your reservation at any time using the link we send you by email. If you wish to book today or book a table for more than one person, please contact us by phone.",
            "reservation": "Reservation",
            "reserve": "Reserve",
            "show-reservation": "Show reservation",
            "statuses": {
                "canceled": {
                    "notice": "Canceled",
                    "sentence": "Your reservation has been canceled",
                    "short": "Canceled",
                    "subject": "Canceled reservation"
                },
                "confirmed": {
                    "notice": "Confirmed by restaurant",
                    "sentence": "Your reservation has been confirmed",
                    "short": "Confirmed",
                    "subject": "Confirmed reservation"
                },
                "new": {
                    "notice": "Successfully sent",
                    "sentence": "We just recieved your reservation",
                    "sentence-admin": "new reservation has just been created",
                    "short": "New",
                    "subject": "New reservation"
                }
            },
            "time": "Time",
            "vue-details": ". | . | Reservation on <strong>{date}</strong> at <strong>{time}</strong> for <strong>{persons}</strong> persons"
        },
        "admin": {
            "action": {
                "add": "Add",
                "choose": "Choose",
                "delete": "Smazat",
                "edit": "Edit",
                "show": "Show"
            },
            "bookmarks": {
                "placement": {
                    "footer": "Footer",
                    "header": "Header"
                },
                "type": {
                    "link": "Link",
                    "page": "Page"
                }
            },
            "buttons": {
                "fill": "Fill"
            },
            "categories": {
                "columns": {
                    "auto": "Automatic",
                    "one": "One",
                    "two": "Two"
                }
            },
            "color": {
                "black": "Černá",
                "danger": "Danger",
                "dark": "Dark",
                "info": "Informative",
                "light": "Light",
                "link": "Link",
                "primary": "Primary",
                "success": "Success",
                "warning": "Warning",
                "white": "Bílá"
            },
            "crud": {
                "exportPdf": "Export PDF",
                "lunchMenu": "Lunch menu"
            },
            "default": "default",
            "display": {
                "accepted": "Accepted",
                "auto": "Automatic",
                "hidden": "Hidden",
                "not_accepted": "Not accepted"
            },
            "entity": {
                "adminReservation": "Manage reservations",
                "adminVouchers": "Manage vouchers",
                "blockedDays": "Blocked days",
                "blog": "Blog",
                "bookmark": "Bookmarks",
                "category": "Categories",
                "content": "Content",
                "contentBox": "Content boxes",
                "currentWeek": "Current week",
                "decoration": "Decorations",
                "gallery": "Galleries",
                "general": "General",
                "help": "Help",
                "homeButton": "Home buttons",
                "icon": "Icons",
                "ingredient": "Ingredients",
                "ingredientGroup": "Ingredient groups",
                "integrations": "Integrations",
                "language": "Languages",
                "lunchFeed": "XML feeds",
                "lunchWeek": "This week, Next week",
                "lunchmenu": "Lunch menus",
                "lunchmenuday": "Lunch days",
                "meal": "Meal",
                "news": "News",
                "nextWeek": "Next week",
                "notification": "Notifications",
                "offer": "Offers",
                "offerMeal": "Meal",
                "offerMenu": "Menus",
                "onlineOrders": {
                    "deliveryTypes": "Delivery methods",
                    "index": "Online sales",
                    "orders": "Orders",
                    "paymentTypes": "Payment methods"
                },
                "openingHour": "Opening hours",
                "openingHourDate": "Specific days",
                "openingHourDay": "Days in week",
                "page": "Pages",
                "partnerProgram": "Partner programme",
                "payment": "Payments",
                "paymentMethod": "Payment methods",
                "paymentType": "Payment openingTypes",
                "reservation": "Reservations",
                "service": "Services",
                "setting": "Settings",
                "socialNetworks": "Social networks",
                "tag": "Tags",
                "voucherValues": "Voucher values",
                "vouchers": "Gift vouchers",
                "webPaymentMethod": "Web payments"
            },
            "export": {
                "fontSize": "Font size",
                "nextWeek": "Next week",
                "range": "Range",
                "spacing": "Spacing",
                "thisWeek": "This week",
                "week": "Week",
                "weekend": "Weekend",
                "workdays": "Workdays"
            },
            "field": {
                "active": "Active",
                "activeLanguage": "Active language",
                "address": "Address",
                "allergens": "Allergens",
                "buttonTitle": "Button text",
                "buttonUrl": "Link",
                "category": "Category",
                "childCategory": "Child category",
                "code": "Code",
                "columns": "Columns count",
                "content": "Content",
                "contentBox": "Content boxes",
                "created_at": "Created at",
                "customer": "Customer",
                "date": "Date",
                "dateFrom": "Date from",
                "dateTo": "Date to",
                "day": "Day of the week",
                "description": "Description",
                "display": "Display",
                "dontShowName": "Do not show name",
                "free_price": "Free from price",
                "highlighted": "Highlighted",
                "icon": "Icon",
                "icon_color": "Icon color",
                "id": "ID",
                "image": "Image",
                "imageType": "Image display type",
                "images": "Images",
                "internal": "Internal label",
                "key": "Key",
                "kitchen": "Kitchen",
                "language": "Language",
                "link": "Link",
                "lunch": "Lunch",
                "mealIcons": "Icons",
                "mealNum": "Number of meals",
                "mealTag": "Tag",
                "menickaCzType": "Category type for menicka.cz XML feed",
                "menu": "Menu card",
                "message": "Message",
                "module": "Module",
                "name": "Name",
                "note": "Note",
                "notificationOnClick": "After click action",
                "notificationType": "Notification type",
                "notificationValidity": "Notification validity",
                "offer": {
                    "text_above": "Text content above offer",
                    "text_below": "Text content below offer"
                },
                "offerAvailability": "Offer availability",
                "offerMeals": {
                    "enabledOrders": "Enabled for online sale",
                    "enabledWeb": "Show on website",
                    "soldOut": "Sold out"
                },
                "offered": "Offered",
                "onlineOrders": {
                    "deliveryType": "Delivery method",
                    "firstname": "Firstname",
                    "lastname": "Lastname",
                    "order": "Order",
                    "orderItems": "Items",
                    "paymentType": "Payment method",
                    "totalPrice": "Total price"
                },
                "open": "Opened",
                "packagingPrice": "Price (packaging)",
                "parentCategory": "Parent category",
                "payed_at": "Paid",
                "person_name": "Name",
                "persons": "Persons",
                "phone": "Phone",
                "placement": "Placement",
                "portion": "Serving",
                "price": "Price",
                "primary": "Primary",
                "primaryLanguage": "Primary language",
                "reason": "Reason",
                "response": "Response",
                "restaurant": "Restaurant",
                "showInMenu": "Show in menu",
                "socialNetwork": "Social network",
                "state": "Status",
                "status": "Status",
                "style": "Style",
                "subtitle": "Subtitle",
                "time": "Time",
                "timeFrom": "From",
                "timeTo": "To",
                "title": "Title",
                "title-image": "Ilustration under title",
                "type": "Type",
                "url": "URL address",
                "validFrom": "Valid from",
                "validTo": "Valid to",
                "validity": "Validity",
                "value": "Value",
                "variable_symbol": "Ref. number"
            },
            "filter": {
                "category": "Category",
                "date": "Date",
                "gallery": "Gallery",
                "general": "General",
                "module": "Module"
            },
            "help": {
                "availableSettings": "Available settings",
                "basicInfo": "Basic information",
                "recommended": "recommended",
                "set": "Settings"
            },
            "hint": {
                "activeLanguage": "Language mutation of the website.<br /><strong>Attention - inappropriate settings may cause the web application to stop working.</strong>",
                "dateTo": "If the date is not set, the opening hour is endless. You can delete it by using the trash icon in the calendar.",
                "internal": "Only used in adminisration panel.",
                "menickaCzType": "Ignore if you do not use menicka.cz XML feed.",
                "notificationContent": "For content to be displayed you must set `After click action` on `Modal` value",
                "notificationLink": "For link to be working you must set `After click action` on `Link` value",
                "notificationOnClick": "\n<ul>\n    <li><b>Nothing</b> - Nothing happens after click.</li>\n    <li><b>Link</b> - Visitor gets redirected.</li>\n    <li><b>Modal</b> - Modal window (popup) with additonal content gets open.</li>\n</ul>",
                "notificationType": "\n<ul>\n    <li><b>Info</b> - Suitable for standard operation information, notification is blue.</li>\n    <li><b>Success</b> - Suitable for new offers or events, notification is green.</li>\n    <li><b>Warning</b> - Suitable for operation blocking events, notification is yellow.</li>\n</ul>",
                "offered": "If the service is offered by the restaurant.",
                "primaryLanguage": "Language mutation of the admin side of the website and default language mutation of the website.<br /><strong>Attention - inappropriate settings may cause the web application to stop working.</strong>",
                "reason": "Note for opening hour",
                "showInMenu": "By turning off you will hide whole item on the website.",
                "type": "Type value changes icon color",
                "validTo": "If the date is not set, the menu has infinite validity. You can delete it by using the trash icon in the calendar.",
                "withoutName": "By checking there is numerical order instead of the name of category. Menu 1 / Menu 2 and so."
            },
            "imageType": {
                "contain": "Contain (picture will not get cropped, not whole area will be filled)",
                "cover": "Cover (whole area will be filled, picture will be cropped)"
            },
            "integrations": {
                "instagram": {
                    "description": "",
                    "name": ""
                }
            },
            "lunchmenuday": {
                "column": {
                    "serving": "We are serving menu"
                },
                "field": {
                    "serving": "We are serving menu"
                },
                "hint": {
                    "reason": "The reason why no lunch menu is served."
                }
            },
            "menickaCzType": {
                "jidlo": "Meal",
                "polevka": "Soup"
            },
            "notificationOnClick": {
                "close": "Nothing",
                "link": "Link",
                "modal": "Modal",
                "popup": "Popup"
            },
            "notificationType": {
                "is-info": "Info",
                "is-success": "Success",
                "is-warning": "Warning"
            },
            "nums": {
                "items": "{0}No items|{1}{num} item|[2,*]{num} items",
                "notifications": "{0}No active notifications|{1}{num} active notification|[2,*]{num} active notifications",
                "reservations": "{0}No unresponded resertvations|{1}{num} new reservation|[2,*]{num} new reservations"
            },
            "offer": {
                "additional": "Additional information about your offer.",
                "hint": "Put all your menu items here."
            },
            "offerMeals": {
                "variant": "variant",
                "variants": "Other variants"
            },
            "operations": {
                "qrCode": "QR code"
            },
            "options": {
                "active": [
                    "Inactive",
                    "Active"
                ],
                "primary": [
                    "No",
                    "Yes"
                ]
            },
            "pages": {
                "blog": "Blog",
                "contact": "Contacts",
                "homepage": "Homepage",
                "lunch_menu": "Lunch menu",
                "offer": "Offer",
                "reservation": "Reservations",
                "vouchers": "Gift vouchers"
            },
            "reservation": {
                "actions": {
                    "cancel": "Cancel reservation",
                    "confirm": "Confirm reservation"
                },
                "notifications": {
                    "canceled": "Reservation has been canceled",
                    "confirmed": "Reservation has been confirmed"
                },
                "sendEmail": "Send notifiation e-mail to customer"
            },
            "sample": {
                "customiseDesign": "Customise your installation",
                "firstTime": "Are you here for the first time?",
                "showInfo": "Show"
            },
            "show-website": "Show website",
            "state": {
                "hidden": "Hidden"
            },
            "validSettings": "Valid settings",
            "vouchers": {
                "appliedSuccess": "Voucher was invalidated.",
                "apply": "Invalidate",
                "pay": "Pay",
                "payedSuccess": "Voucher was paid."
            },
            "webPaymentMethod": {
                "bank_transfer": "Bank trasnfer",
                "in_person": "In person on premise",
                "stripe": "Stripe - online payment"
            },
            "webPaymentMethodHint": {
                "bank_transfer": "Bank account number must be set in web payment settings.",
                "in_person": "Address must be set in contact settings.",
                "stripe": "Live Stripe API keys must be set in web payment settings."
            }
        },
        "orders": {
            "actions": {
                "addMoreItems": "Add more items",
                "addNote": "Add note",
                "back": "Back",
                "backMoreItems": "Back to items",
                "manage": "Manage order",
                "order": "Order",
                "orderOnline": "Order online",
                "removeNote": "Remove note",
                "show": "Show order"
            },
            "address": "Address",
            "cart": "Shopping cart",
            "cartContent": "In cart",
            "customer": "Customer",
            "delivery": "Delivery",
            "deliveryAddress": "Delivery address",
            "deliveryType": "Delivery method",
            "deliveryTypes": {
                "delivery": "Delivery",
                "takeaway": "Takeaway"
            },
            "email": "E-mail",
            "firstname": "Firstname",
            "lastname": "Lastname",
            "mail": {
                "stateChange": "order status has changed",
                "states": {
                    "CANCELLED": {
                        "state": "Your order was cancelled.",
                        "title": "Order {number} cacnelled"
                    },
                    "CONFIRMED": {
                        "state": "Order has been confirmed by a person. ",
                        "title": "Order number {number} has been confirmed."
                    },
                    "NEW": {
                        "state": "Your order was created.",
                        "title": "Order number {number} was created."
                    },
                    "ON_DELIVERY": {
                        "state": "Food is on the way.",
                        "title": "Food is on the way - Order number {number}"
                    },
                    "PENDING_PAYMENT": {
                        "state": "Your order is awaiting payment.",
                        "title": "Request for payment of order number {number}"
                    },
                    "READY_TO_PICKUP": {
                        "state": "The food is ready to be picked up.",
                        "title": "Ready to pick up - Order number {number}"
                    },
                    "restaurant_NEW": {
                        "state": "You have a new online order.",
                        "title": "New online order number {number}"
                    }
                }
            },
            "method": "Method",
            "note": "Note",
            "order": "Order",
            "orderNum": "Order number",
            "orderNumber": "Order number {number}",
            "orderOnline": "Order online",
            "ordering": {
                "active": "Ordering is active",
                "paused": "Ordering is paused"
            },
            "orders": "Orders",
            "packaging": "Pacakging",
            "paidAt": "Paid",
            "payment": "Payment",
            "paymentAndDelivery": "Payment and delivery",
            "paymentType": "Payment method",
            "paymentTypes": {
                "card_on_delivery": "Card on delivery",
                "cash": "Cash",
                "meal_vouchers": "Meal vouchers",
                "online_stripe": "Card online"
            },
            "phone": "Phone",
            "state": "State",
            "states": {
                "CANCELLED": "Cancelled",
                "CLOSED": "Closed",
                "CONFIRMED": "Confirmed",
                "CREATING": "Creating",
                "NEW": "New",
                "ON_DELIVERY": "On delivery",
                "PAYMENT_PENDING": "Payment pending",
                "READY_TO_DELIVERY": "Ready to delivery",
                "READY_TO_PICKUP": "Ready to pickup"
            },
            "stripe": {
                "canceled": "Online card payment failed.",
                "paymentRedirect": "Redirecting to payment gateway..."
            },
            "total": "Total",
            "zeroItems": "Cart is empty"
        }
    }
}
